// import XLSX from 'sheetjs-style';
import ExcelJS from 'exceljs';
import FileSaver  from 'file-saver';
import {breakTitle} from "../../../Custom/Custom";

 
export const generateExcel = async (excelObjectData) => {

  const workbook = new ExcelJS.Workbook();
  const worksheet = workbook.addWorksheet(excelObjectData.sheetName);

  //First Row Design and Merge cells A1:L1
  worksheet.mergeCells(excelObjectData.firstRowMergeCells);
  const firstHeaderRow = worksheet.getRow(1);
  firstHeaderRow.getCell(1).value = excelObjectData.firstRowText
  firstHeaderRow.getCell(1).font = { bold: true,name: 'SansSerif',size:14 };
  firstHeaderRow.getCell(1).alignment = { horizontal: 'center',vertical: 'middle',wrapText: true };
  firstHeaderRow.height = 30;
  firstHeaderRow.getCell(excelObjectData.firstRowCellNumber).value = excelObjectData.firstRowExportDate; 
  firstHeaderRow.getCell(excelObjectData.firstRowCellNumber).font = { bold: true,name: 'SansSerif',size:8 }; //cell No- 13
  firstHeaderRow.getCell(excelObjectData.firstRowCellNumber).alignment = { horizontal: 'center',vertical: 'middle',wrapText: true };
  
  //Second Row Design and  Merge cells A2:L2
  worksheet.mergeCells(excelObjectData.secondRowMergeCells); 
  const secondHeaderRow = worksheet.getRow(2);
  secondHeaderRow.getCell(1).value = excelObjectData.secondRowText;
  secondHeaderRow.getCell(1).font = { name: 'SansSerif',size:12};
  secondHeaderRow.getCell(1).alignment = { horizontal: 'center',vertical: 'middle',wrapText: true};
  secondHeaderRow.height = 20;
  secondHeaderRow.getCell(1).border = {
    top: { style: 'thin' },
    left: { style: 'thin' },
    bottom: { style: 'thin' },
    right: { style: 'thin' },
  };
  
 
    //excel English Column
    const headerRow3 = worksheet.addRow(excelObjectData.headerEnglishColumns);
    headerRow3.height=55;
    headerRow3.eachCell((cell,colNumber ) => {
      cell.font = { bold: true, name: 'SansSerif',size:10};
      cell.alignment = { horizontal: 'center',vertical: 'middle',wrapText: true };
      cell.value = breakTitle(cell.value);
      cell.border = {
        top: { style: 'thin' },
        left: { style: 'thin' },
        bottom: { style: 'thin' },
        right: { style: 'thin' },
        
      };
      const column = worksheet.getColumn(colNumber);
      column.width = 16;
        
     });
    

      //excel Hindi Column
    const headerRow4 = worksheet.addRow(excelObjectData.headerHindiColumns);
    headerRow4.height=55;
    headerRow4.eachCell((cell,colNumber) => {
      cell.font = { bold: true, name: 'SansSerif',size:10 };
      cell.alignment = { horizontal: 'center',vertical: 'middle',wrapText: true };
      cell.value = breakTitle(cell.value);
      cell.width=50;
      cell.border = {
        top: { style: 'thin' },
        left: { style: 'thin' },
        bottom: { style: 'thin' },
        right: { style: 'thin' },
      };
      const column = worksheet.getColumn(colNumber);
      
      column.width = 16;
     });
  

  
  
    excelObjectData.excelRowData.forEach((row) => {  //Excel Data Loop
      const dataRow = worksheet.addRow(row);
      dataRow.height=27;
      row.forEach((value, index) => {
        const cell = dataRow.getCell(index + 1);
        cell.font = {  name: 'SansSerif',size:10 };
        cell.alignment = { horizontal: 'center',vertical: 'middle',wrapText: true };
        cell.border = {
          top: { style: 'thin' },
          left: { style: 'thin' },
          bottom: { style: 'medium' },
          right: { style: 'thin' },
        };
        // Customize styling for the cells if needed
      });
     
    });
    const buffer = await workbook.xlsx.writeBuffer();
    const blob = new Blob([buffer], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=UTF-8' });
    const fileName=`${excelObjectData.fileName}.${excelObjectData.fileType}`;
    FileSaver.saveAs(blob, fileName);
};


  
export const generateExcelASI = async (excelObjectData) => {

  const workbook = new ExcelJS.Workbook();
  const worksheet = workbook.addWorksheet(excelObjectData.sheetName);

  //First Row Design and Merge cells A1:K1
  worksheet.mergeCells(excelObjectData.firstRowMergeCells);
  const firstHeaderRow = worksheet.getRow(1);
  firstHeaderRow.getCell(1).value = excelObjectData.firstRowExportDate
  firstHeaderRow.getCell(1).font = { bold: true, name: 'SansSerif', size: 20, color: { argb: 'ff7966' } };
  firstHeaderRow.getCell(1).alignment = { horizontal: 'center', vertical: 'middle', wrapText: true };
  firstHeaderRow.height = 30;

  //Second Row Design and  Merge cells A2:K1
  worksheet.mergeCells(excelObjectData.secondRowMergeCells);
  const secondHeaderRow = worksheet.getRow(2);
  secondHeaderRow.getCell(1).value = excelObjectData.secondRowText;
  secondHeaderRow.getCell(1).font = { bold: true, name: 'SansSerif', size: 12 };
  secondHeaderRow.getCell(1).alignment = { horizontal: 'center', vertical: 'middle', wrapText: true };
  secondHeaderRow.height = 20;
  secondHeaderRow.getCell(1).border = {
    top: { style: 'thin' },
    left: { style: 'thin' },
    bottom: { style: 'thin' },
    right: { style: 'thin' },
  };


  
//Third Row Design and  Merge cells A3:L3

  // worksheet.mergeCells(excelObjectData.thirdRowMergeCells); 
  // const thirdHeaderRow = worksheet.getRow(3);
  // thirdHeaderRow.getCell(1).value = excelObjectData.thirdRowText;
  // thirdHeaderRow.getCell(1).font = { name: 'SansSerif',size:12};
  // thirdHeaderRow.getCell(1).alignment = { horizontal: 'center',vertical: 'middle',wrapText: true};
  // thirdHeaderRow.height = 20;
  // thirdHeaderRow.getCell(1).border = {
  //   top: { style: 'thin' },
  //   left: { style: 'thin' },
  //   bottom: { style: 'thin' },
  //   right: { style: 'thin' },
  // };


  //Fourth Row Design and  Merge cells A3:L3

  // worksheet.mergeCells(excelObjectData.fourthRowMergeCells); 
  // const fourthHeaderRow = worksheet.getRow(4);
  // fourthHeaderRow.getCell(1).value = excelObjectData.fourthRowText;
  // fourthHeaderRow.getCell(1).font = { name: 'SansSerif',size:12};
  // fourthHeaderRow.getCell(1).alignment = { horizontal: 'center',vertical: 'middle',wrapText: true};
  // fourthHeaderRow.height = 20;
  // fourthHeaderRow.getCell(1).border = {
  //   top: { style: 'thin' },
  //   left: { style: 'thin' },
  //   bottom: { style: 'thin' },
  //   right: { style: 'thin' },
  // };
 
    //excel English Column
    const headerRow3 = worksheet.addRow(excelObjectData.headerEnglishColumns);
    headerRow3.height=55;
    headerRow3.eachCell((cell,colNumber ) => {
      cell.font = { bold: true, name: 'SansSerif',size:10};
      cell.alignment = { horizontal: 'center',vertical: 'middle',wrapText: true };
      cell.value = breakTitle(cell.value);
      cell.border = {
        top: { style: 'thin' },
        left: { style: 'thin' },
        bottom: { style: 'thin' },
        right: { style: 'thin' },
        
      };
      const column = worksheet.getColumn(colNumber);
      column.width = 25;
        
     });
    
    excelObjectData.excelRowData.forEach((row) => {  //Excel Data Loop
      const dataRow = worksheet.addRow(row);
      dataRow.height=null;
      let isTotalRow = false;
      row.forEach((value, index) => {
        const cell = dataRow.getCell(index + 1);
        cell.font = {  name: 'SansSerif',size:10 };
        cell.alignment = { horizontal: 'center',vertical: 'middle',wrapText: true };
        cell.border = {
          top: { style: 'thin' },
          left: { style: 'thin' },
          bottom: { style: 'thin' },
          right: { style: 'thin' },
        };
        if (value === 'TOTAL') {
          isTotalRow = true;
        }
        // Customize styling for the cells if needed
      });

      if (isTotalRow) {
        dataRow.eachCell({ includeEmpty: true }, (cell) => {
          cell.font = { name: 'SansSerif', size: 12, bold: true };
        });
      }
     
    });
    const buffer = await workbook.xlsx.writeBuffer();
    const blob = new Blob([buffer], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=UTF-8' });
    const fileName=`${excelObjectData.fileName}.${excelObjectData.fileType}`;
    FileSaver.saveAs(blob, fileName);
};



export const generateExcelASITable1 = async (excelObjectData) => {
  const workbook = new ExcelJS.Workbook();
  const worksheet = workbook.addWorksheet(excelObjectData.sheetName);
  const year = excelObjectData.yearName;
  const isYear2017 = excelObjectData.sheetName.includes('2017');
  worksheet.mergeCells(excelObjectData.firstRowMergeCells);
  const firstHeaderRow = worksheet.getRow(1);
  firstHeaderRow.getCell(1).value = excelObjectData.firstRowExportData;
  firstHeaderRow.getCell(1).font = { name: 'SansSerif', size: 20 };
  firstHeaderRow.getCell(1).alignment = { horizontal: 'center', vertical: 'middle', wrapText: true };
  firstHeaderRow.height = 30;

  // Second Row Design and Merge cells
  worksheet.mergeCells(excelObjectData.secondRowMergeCells);
  const secondHeaderRow = worksheet.getRow(2);
  secondHeaderRow.getCell(1).value = excelObjectData.secondRowText;
  secondHeaderRow.getCell(1).font = { bold: true, name: 'SansSerif', size: 12 };
  secondHeaderRow.getCell(1).alignment = { horizontal: 'center', vertical: 'middle', wrapText: true };
  secondHeaderRow.height = 30;
  secondHeaderRow.getCell(1).border = {
    top: { style: 'thin' },
    left: { style: 'thin' },
    bottom: { style: 'thin' },
    right: { style: 'thin' },
  };

  // Third Row Design and Merge cells
  worksheet.mergeCells(excelObjectData.thirdRowMergeCells);
  const thirdHeaderRow = worksheet.getRow(3);
  thirdHeaderRow.getCell(1).value = excelObjectData.thirdRowText;
  thirdHeaderRow.getCell(1).font = { bold: true, name: 'SansSerif', size: 12 };
  thirdHeaderRow.getCell(1).alignment = { horizontal: 'center', vertical: 'middle', wrapText: true };
  thirdHeaderRow.height = 30;
  thirdHeaderRow.getCell(1).border = {
    top: { style: 'thin' },
    left: { style: 'thin' },
    bottom: { style: 'thin' },
    right: { style: 'thin' },
  };
  // Conditional header rows and merging
  if (year == 2017 || year === "2017") {
    const headerRow1 = worksheet.addRow([
      'उत्तर प्रदेश', "", "", 'मूल्य हज़ार रुपए तथा अन्य संख्या में ', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', ''
    ]);
    headerRow1.height = 20;
    worksheet.mergeCells('A4:C4');
    worksheet.mergeCells('D4:AJ4');
    

    const headerRow2 = worksheet.addRow([
      'मण्डल', 'जनपद', 'उद्योग संकेत\n(4 अंकीय )\n(एन.आई.सी. 2008 )', 'कारखानों की संख्या ', '', '', 'Fixed Capital', 'Physical Working Capital', 'Working Capital', 'Invested Capital',
      'Gross Value of additions to fixed Capital', 'Rent Paid', 'Outstanding Loan', 'Interest Paid', 'Rent Received', 'Interest Received', 'Gross Value of P& M', 'Value of Products &  By-Products',
      'Other Output', 'Tatal Output', 'Fuels Consumed', 'Materials Consumed for Manufacturing', 'Other Input', 'Total Input', 'GVA', 'Depreciation', 'NVA', 'Net Fixed Capital Formation(NFCF)',
      'Gross Fixed Capital Formation (GFCF)', 'Materials, Fuels etc', 'Semi-Finished Goods', 'Finished Goods', 'Total', 'Gross Capital Formation', 'Net income', 'Profit'
    ]);
    headerRow2.height = 35;

    const headerRow3 = worksheet.addRow([
      '', '', '', 'पंजीकृत', 'कार्यरत', 'अनुमानित', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', ''
    ]);
    headerRow3.height = 20;

    headerRow1.eachCell((cell, colNumber) => {
      cell.font = { bold: true, name: 'SansSerif', size: 10 };
      cell.alignment = { horizontal: 'center', vertical: 'middle', wrapText: true };
      cell.border = {
        top: { style: 'thin' },
        left: { style: 'thin' },
        bottom: { style: 'thin' },
        right: { style: 'thin' },
      };
    });

    headerRow2.eachCell((cell, colNumber) => {
      cell.font = { bold: true, name: 'SansSerif', size: 10 };
      cell.alignment = { horizontal: 'center', vertical: 'middle', wrapText: true };
      cell.border = {
        top: { style: 'thin' },
        left: { style: 'thin' },
        bottom: { style: 'thin' },
        right: { style: 'thin' },
      };
    });

    headerRow3.eachCell((cell, colNumber) => {
      cell.font = { bold: true, name: 'SansSerif', size: 10 };
      cell.alignment = { horizontal: 'center', vertical: 'middle', wrapText: true };
      cell.border = {
        top: { style: 'thin' },
        left: { style: 'thin' },
        bottom: { style: 'thin' },
        right: { style: 'thin' },
      };
    });

    worksheet.mergeCells('A5:A6');
    worksheet.mergeCells('B5:B6');
    worksheet.mergeCells('C5:C6');
    worksheet.mergeCells('G5:G6');
    worksheet.mergeCells('H5:H6');
    worksheet.mergeCells('I5:I6');
    worksheet.mergeCells('J5:J6');
    worksheet.mergeCells('K5:K6');
    worksheet.mergeCells('L5:L6');
    worksheet.mergeCells('M5:M6');
    worksheet.mergeCells('N5:N6');
    worksheet.mergeCells('O5:O6');
    worksheet.mergeCells('P5:P6');
    worksheet.mergeCells('Q5:Q6');
    worksheet.mergeCells('R5:R6');
    worksheet.mergeCells('S5:S6');
    worksheet.mergeCells('T5:T6');
    worksheet.mergeCells('U5:U6');
    worksheet.mergeCells('V5:V6');
    worksheet.mergeCells('W5:W6');
    worksheet.mergeCells('X5:X6');
    worksheet.mergeCells('Y5:Y6');
    worksheet.mergeCells('Z5:Z6');
    worksheet.mergeCells('AA5:AA6');
    worksheet.mergeCells('AB5:AB6');
    worksheet.mergeCells('AC5:AC6');
    worksheet.mergeCells('AD5:AD6');
    worksheet.mergeCells('AE5:AE6');
    worksheet.mergeCells('AF5:AF6');
    worksheet.mergeCells('AG5:AG6');
    worksheet.mergeCells('AH5:AH6');
    worksheet.mergeCells('AI5:AI6');
    worksheet.mergeCells('AJ5:AJ6');

  } else if (year == 2023 || year === "2023") {
    const headerRow1 = worksheet.addRow([
      'उत्तर प्रदेश',
      '',
      '',
      'मूल्य हज़ार रुपए तथा अन्य संख्या में ',
      ...Array(30).fill(''),
    ]);
    headerRow1.height = 20;
    headerRow1.eachCell((cell) => {
      cell.font = { bold: true, name: 'Calibri', size: 11 };
      cell.alignment = { horizontal: 'center', vertical: 'middle', wrapText: true };
      cell.border = {
        top: { style: 'thin' },
        left: { style: 'thin' },
        bottom: { style: 'thin' },
        right: { style: 'thin' },
      };
    });
    worksheet.mergeCells('A4:C4');
    worksheet.mergeCells('D4:AH4');
    worksheet.getCell('A4').value = 'उत्तर प्रदेश';
    worksheet.getCell('D4').value = 'मूल्य हज़ार रुपए तथा अन्य संख्या में ';
    worksheet.getCell('A4').font = { bold: true, name: 'Calibri', size: 11 };
    worksheet.getCell('D4').font = { bold: true, name: 'Calibri', size: 11 };
    worksheet.getCell('A4').alignment = { horizontal: 'center', vertical: 'middle', wrapText: true };
    worksheet.getCell('D4').alignment = { horizontal: 'center', vertical: 'middle', wrapText: true };

    const headerRow2 = worksheet.addRow([
      'उद्योग संकेत\n(4 अंकीय )\n(एन.आई.सी. 2008 )',
      'कारखानों की संख्या',
      '',
      '',
      'स्थायी पूँजी',
      'भौतिक कार्यशील पूँजी',
      'कार्यशील पूँजी',
      'निवेशित पूँजी',
      'स्थायी पूँजी में वृद्धि का सकल मूल्य',
      'किराया देय',
      'अदेय ऋण',
      'देय ब्याज',
      'प्राप्त किराया',
      'प्राप्त ब्याज',
      'संयंत्र एवं मशीनरी का सकल मूल्य',
      'उत्पाद एवं उप-उत्पादों का मूल्य',
      'अन्य उत्पादन',
      'कुल उत्पादन',
      'ईंधन की खपत',
      'विनिर्माण हेतु खप्त सामग्री',
      'अन्य निवेश',
      'कुल निवेश',
      'सकल आवर्धित मूल्य',
      'मूल्य ह्रास',
      'शुद्ध आवर्धित मूल्य',
      'शुद्ध स्थायी पूँजी निर्माण',
      'सकल स्थायी पूँजी निर्माण',
      'सामग्री, ईंधन आदि',
      'अर्ध निर्मित वस्तुएँ',
      'तैयार माल',
      'योग',
      'सकल पूँजी निर्माण',
      'शुद्ध आय',
      'लाभ',
    ]);
    headerRow2.height = 35;

    const headerRow3 = worksheet.addRow([
      '',
      'पंजीकृत',
      'कार्यरत',
      'अनुमानित',
      ...Array(30).fill(''),
    ]);
    headerRow3.height = 20;

    headerRow2.eachCell((cell) => {
      cell.font = { bold: true, name: 'SansSerif', size: 10 };
      cell.alignment = { horizontal: 'center', vertical: 'middle', wrapText: true };
      cell.border = {
        top: { style: 'thin' },
        left: { style: 'thin' },
        bottom: { style: 'thin' },
        right: { style: 'thin' },
      };
    });

    headerRow3.eachCell((cell) => {
      cell.font = { bold: true, name: 'SansSerif', size: 10 };
      cell.alignment = { horizontal: 'center', vertical: 'middle', wrapText: true };
      cell.border = {
        top: { style: 'thin' },
        left: { style: 'thin' },
        bottom: { style: 'thin' },
        right: { style: 'thin' },
      };
    });

    worksheet.mergeCells('A5:A6');
    worksheet.mergeCells('B5:D5');
    const mergeCols2023 = [
      'E', 'F', 'G', 'H', 'I', 'J', 'K', 'L', 'M', 'N', 'O', 'P', 'Q', 'R', 'S', 'T', 'U', 'V', 'W', 'X', 'Y', 'Z',
      'AA', 'AB', 'AC', 'AD', 'AE', 'AF', 'AG', 'AH',
    ];
    mergeCols2023.forEach((col) => {
      worksheet.mergeCells(`${col}5:${col}6`);
    });

  } else {
    const headerRow1 = worksheet.addRow([
      'उत्तर प्रदेश',
      'मूल्य हज़ार रुपए तथा अन्य संख्या में ',
      '',
      '',
      '',
      '',
      '',
      '',
      '',
      '',
      '',
      '',
      '',
      '',
      '',
      '',
      '',
      '',
      '',
    ]);
    headerRow1.height = 20;
    headerRow1.eachCell((cell, colNumber) => {
      cell.font = { bold: true, name: 'Calibri', size: 11 };
      cell.alignment = { horizontal: 'center', vertical: 'middle', wrapText: true };
      cell.border = {
        top: { style: 'thin' },
        left: { style: 'thin' },
        bottom: { style: 'thin' },
        right: { style: 'thin' },
      };
    });
    worksheet.mergeCells('B4:S4');
    const cellA4 = worksheet.getCell('A4');
    const cellB4 = worksheet.getCell('B4');
    cellA4.value = 'उत्तर प्रदेश';
    cellB4.value = 'मूल्य हज़ार रुपए तथा अन्य संख्या में ';
    cellA4.font = { bold: true, name: 'Calibri', size: 11 };
    cellB4.font = { bold: true, name: 'Calibri', size: 11 };
    cellA4.alignment = { horizontal: 'center', vertical: 'middle', wrapText: true };
    cellB4.alignment = { horizontal: 'center', vertical: 'middle', wrapText: true };

    const headerRow2 = worksheet.addRow([
      'उद्योग संकेत\n(4 अंकीय )\n(एन.आई.सी. 2008 )', 'कारखानों की संख्या ', '', '', 'स्थायी पूँजी ', 'भौतिक कार्यशील पूँजी', 'विनियोजित  पूँजी', 'उपभुक्त सामग्री',
      'कुल आगत', 'कुल निर्गत', 'उत्पादन का मूल्य', 'सकल आवर्धित मूल्य', 'मूल्य ह्रास', 'शुद्ध आवर्धित मूल्य', 'शुद्ध स्थायी पूँजी विनिर्माण', 'सकल  स्थायी पूँजी विनिर्माण',
      'शुद्ध आय', 'लाभ', 'सकल पूँजी निर्माण'
    ]);
    headerRow2.height = 35;

    const headerRow3 = worksheet.addRow([
      '', 'पंजीकृत', 'कार्यरत', 'अनुमानित', '', '', '', '', '', '', '', '', '', '', '', '', '', '', ''
    ]);
    headerRow3.height = 20;

    headerRow2.eachCell((cell, colNumber) => {
      cell.font = { bold: true, name: 'SansSerif', size: 10 };
      cell.alignment = { horizontal: 'center', vertical: 'middle', wrapText: true };
      cell.border = {
        top: { style: 'thin' },
        left: { style: 'thin' },
        bottom: { style: 'thin' },
        right: { style: 'thin' },
      };
    });

    headerRow3.eachCell((cell, colNumber) => {
      cell.font = { bold: true, name: 'SansSerif', size: 10 };
      cell.alignment = { horizontal: 'center', vertical: 'middle', wrapText: true };
      cell.border = {
        top: { style: 'thin' },
        left: { style: 'thin' },
        bottom: { style: 'thin' },
        right: { style: 'thin' },
      };
    });

    worksheet.mergeCells('A5:A6');
    worksheet.mergeCells('B5:D5');
    const mergeColsDefaultTable1 = [
      'E', 'F', 'G', 'H', 'I', 'J', 'K', 'L', 'M', 'N', 'O', 'P', 'Q', 'R', 'S',
    ];
    mergeColsDefaultTable1.forEach((col) => {
      worksheet.mergeCells(`${col}5:${col}6`);
    });
  }

  // Adjust column widths for all header rows
  worksheet.columns.forEach((column) => {
    column.width = 15;
  });

  // Add data rows
  excelObjectData.excelRowData.forEach((row) => {
    const dataRow = worksheet.addRow(row);
    dataRow.height = null;
    let isTotalRow = false;
    row.forEach((value, index) => {
      const cell = dataRow.getCell(index + 1);
      cell.font = { name: 'SansSerif', size: 10 };
      cell.alignment = { horizontal: 'center', vertical: 'middle', wrapText: true };
      cell.border = {
        top: { style: 'thin' },
        left: { style: 'thin' },
        bottom: { style: 'thin' },
        right: { style: 'thin' },
      };
      if (value === 'TOTAL') {
        isTotalRow = true;
      }
      // Customize styling for the cells if needed
    });

    if (isTotalRow) {
      dataRow.eachCell({ includeEmpty: true }, (cell) => {
        cell.font = { name: 'SansSerif', size: 12, bold: true };
      });
    }
  });

  // Add totals row
  const totalsRow = worksheet.addRow([]);
  for (let col = 2; col <= 34; col++) {
    let total = 0;
    for (let row = 6; row < excelObjectData.excelRowData.length + 6; row++) {
      const value = worksheet.getCell(row + 1, col).value;
      const numValue = parseFloat(value);
      if (!isNaN(numValue)) {
        total += numValue;
      }
    }
    const totalCell = totalsRow.getCell(col);
    totalCell.value = total;
    totalCell.font = { name: 'SansSerif', size: 10, bold: true };
    totalCell.alignment = { horizontal: 'center', vertical: 'middle', wrapText: true };
    totalCell.border = {
      top: { style: 'thin' },
      left: { style: 'thin' },
      bottom: { style: 'thin' },
      right: { style: 'thin' },
    };
  }
  totalsRow.height = 20;

  // Adjust column widths to fit the content
  worksheet.columns.forEach((column) => {
    column.width = Math.max(column.width || 10, 15);
  });

  const buffer = await workbook.xlsx.writeBuffer();
  const blob = new Blob([buffer], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=UTF-8' });
  const fileName = `${excelObjectData.fileName}.${excelObjectData.fileType}`;
  FileSaver.saveAs(blob, fileName);
};




export const generateExcelASITable1For2017 = async (excelObjectData) => {
  const workbook = new ExcelJS.Workbook();
  const worksheet = workbook.addWorksheet(excelObjectData.sheetName);

 
  // First Row Design and Merge cells
  worksheet.mergeCells(excelObjectData.firstRowMergeCells);
  const firstHeaderRow = worksheet.getRow(1);
  firstHeaderRow.getCell(1).value = excelObjectData.firstRowExportData;
  firstHeaderRow.getCell(1).font = { name: 'SansSerif', size: 11 };
  firstHeaderRow.getCell(1).alignment = { horizontal: 'right', vertical: 'middle', wrapText: true };
  firstHeaderRow.height = 30;

  // Second Row Design and Merge cells
  worksheet.mergeCells(excelObjectData.secondRowMergeCells);
  const secondHeaderRow = worksheet.getRow(2);
  secondHeaderRow.getCell(1).value = excelObjectData.secondRowText;
  secondHeaderRow.getCell(1).font = { bold: true, name: 'SansSerif', size: 14 };
  secondHeaderRow.getCell(1).alignment = { horizontal: 'center', vertical: 'middle', wrapText: true };
  secondHeaderRow.height = 30;
  secondHeaderRow.getCell(1).border = {
    top: { style: 'thin' },
    left: { style: 'thin' },
    bottom: { style: 'thin' },
    right: { style: 'thin' },
  };

  // Third Row Design and Merge cells
  worksheet.mergeCells(excelObjectData.thirdRowMergeCells);
  const thirdHeaderRow = worksheet.getRow(3);
  thirdHeaderRow.getCell(1).value = excelObjectData.thirdRowText;
  thirdHeaderRow.getCell(1).font = { bold: true, name: 'SansSerif', size: 14 };
  thirdHeaderRow.getCell(1).alignment = { horizontal: 'center', vertical: 'middle', wrapText: true };
  thirdHeaderRow.height = 30;
  thirdHeaderRow.getCell(1).border = {
    top: { style: 'thin' },
    left: { style: 'thin' },
    bottom: { style: 'thin' },
    right: { style: 'thin' },
  };


  // Fourth Row Design and Merge cells
  worksheet.mergeCells(excelObjectData.fourthRowMergeCells);
  const fourthHeaderRow = worksheet.getRow(4);
  fourthHeaderRow.getCell(1).value = excelObjectData.forthRowText;
  fourthHeaderRow.getCell(1).font = { bold: true, name: 'SansSerif', size: 14 };
  fourthHeaderRow.getCell(1).alignment = { horizontal: 'center', vertical: 'middle', wrapText: true };
  fourthHeaderRow.height = 30;
  fourthHeaderRow.getCell(1).border = {
    top: { style: 'thin' },
    left: { style: 'thin' },
    bottom: { style: 'thin' },
    right: { style: 'thin' },
  };


    

  const headerRow5 = worksheet.addRow(excelObjectData.fifthRowText);
  headerRow5.height = 35;
  headerRow5.eachCell((cell, colNumber) => {
    cell.font = { bold: true, name: 'SansSerif', size: 12 };
    cell.alignment = { horizontal: 'center', vertical: 'middle', wrapText: true };
    cell.border = {
      top: { style: 'thin' },
      left: { style: 'thin' },
      bottom: { style: 'thin' },
      right: { style: 'thin' },
    };
  });

  worksheet.mergeCells('B5:S5')



  const headerRow6 = worksheet.addRow(excelObjectData.sixRowText);
  headerRow6.eachCell((cell, colNumber) => {
    cell.font = { bold: true, name: 'SansSerif', size: 10 };
    cell.alignment = { horizontal: 'center', vertical: 'middle', wrapText: true };
    cell.border = {
      top: { style: 'thin' },
      left: { style: 'thin' },
      bottom: { style: 'thin' },
      right: { style: 'thin' },
    };
    const column = worksheet.getColumn(colNumber);
    if(colNumber===1){
      column.width = 20;
    }else if([2,3,4].includes(colNumber)){
      column.width = 10;
    }else{
      column.width = 16;
    }
   
  });







  const headerRow7 = worksheet.addRow(excelObjectData.seventhRow);
  headerRow7.eachCell((cell, colNumber) => {
    cell.font = { bold: true, name: 'SansSerif', size: 10 };
    cell.alignment = { horizontal: 'center', vertical: 'middle', wrapText: true };
    cell.border = {
      top: { style: 'thin' },
      left: { style: 'thin' },
      bottom: { style: 'thin' },
      right: { style: 'thin' },
    };
  });

  worksheet.mergeCells("A6:A7")
  worksheet.mergeCells("B6:D6")
  worksheet.mergeCells("E6:E7")
  worksheet.mergeCells("F6:F7")
  worksheet.mergeCells("G6:G7")
  worksheet.mergeCells("H6:H7")
  worksheet.mergeCells("I6:I7")
  worksheet.mergeCells("J6:J7")
  worksheet.mergeCells("K6:K7")
  worksheet.mergeCells("L6:L7")
  worksheet.mergeCells("M6:M7")
  worksheet.mergeCells("N6:N7")
  worksheet.mergeCells("O6:O7")
  worksheet.mergeCells("P6:P7")
  worksheet.mergeCells("Q6:Q7")
  worksheet.mergeCells("R6:R7")
  worksheet.mergeCells("S6:S7")

  // Add data rows
  excelObjectData.excelRowData.forEach((row) => {
    const dataRow = worksheet.addRow(row);
    dataRow.height = 20;
    let isTotalRow = false;
    row.forEach((value, index) => {
      const cell = dataRow.getCell(index + 1);
      cell.font = { name: 'SansSerif', size: 10 };
      cell.alignment = { horizontal: 'center', vertical: 'middle', wrapText: true };
      cell.border = {
        top: { style: 'thin' },
        left: { style: 'thin' },
        bottom: { style: 'thin' },
        right: { style: 'thin' },
      };
      if (value === 'TOTAL') {
        isTotalRow = true;
      }
      // Customize styling for the cells if needed
    });

    if (isTotalRow) {
      dataRow.eachCell({ includeEmpty: true }, (cell) => {
        cell.font = { name: 'SansSerif', size: 12, bold: true };
      });
    }
  });

  // Add totals row
  const totalsRow = worksheet.addRow([]);
  for (let col = 2; col <= 19; col++) {
    let total = 0;
    for (let row = 6; row < excelObjectData.excelRowData.length + 6; row++) {
      const value = worksheet.getCell(row + 1, col).value;
      const numValue = parseFloat(value);
      if (!isNaN(numValue)) {
        total += numValue;
      }
    }
    const totalCell = totalsRow.getCell(col);
    totalCell.value = total;
    totalCell.font = { name: 'SansSerif', size: 10, bold: true };
    totalCell.alignment = { horizontal: 'center', vertical: 'middle', wrapText: true };
    totalCell.border = {
      top: { style: 'thin' },
      left: { style: 'thin' },
      bottom: { style: 'thin' },
      right: { style: 'thin' },
    };
  }
  // totalsRow.height = 20;

  // // Adjust column widths to fit the content
  worksheet.columns.forEach((column) => {
    column.width = Math.max(column.width || 10, 15);
  });

  const buffer = await workbook.xlsx.writeBuffer();
  const blob = new Blob([buffer], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=UTF-8' });
  const fileName = `${excelObjectData.fileName}.${excelObjectData.fileType}`;
  FileSaver.saveAs(blob, fileName);
};


export const generateExcelASITable2 = async (excelObjectData) => {
  const year = excelObjectData.yearName;
  const is2023 = year == 2023 || year === "2023";

  const workbook = new ExcelJS.Workbook();
  const worksheet = workbook.addWorksheet(excelObjectData.sheetName);

  //First Row Design and Merge cells A1:U1
  worksheet.mergeCells(excelObjectData.firstRowMergeCells);
  const firstHeaderRow = worksheet.getRow(1);
  firstHeaderRow.getCell(1).value = excelObjectData.firstRowExportData
  firstHeaderRow.getCell(1).font = { name: 'SansSerif',size:20};
  firstHeaderRow.getCell(1).alignment = { horizontal: 'center',vertical: 'middle',wrapText: true };
  firstHeaderRow.height = 30;
 
  
  //Second Row Design and  Merge cells A2:U2
  worksheet.mergeCells(excelObjectData.secondRowMergeCells); 
  const secondHeaderRow = worksheet.getRow(2);
  secondHeaderRow.getCell(1).value = excelObjectData.secondRowText;
  secondHeaderRow.getCell(1).font = { bold: true, name: 'SansSerif',size:12};
  secondHeaderRow.getCell(1).alignment = { horizontal: 'center',vertical: 'middle',wrapText: true};
  secondHeaderRow.height = 30;
  secondHeaderRow.getCell(1).border = {
    top: { style: 'thin' },
    left: { style: 'thin' },
    bottom: { style: 'thin' },
    right: { style: 'thin' },
  };


  
// Third Row Design and  Merge cells A3:U3

  worksheet.mergeCells(excelObjectData.thirdRowMergeCells); 
  const thirdHeaderRow = worksheet.getRow(3);
  thirdHeaderRow.getCell(1).value = excelObjectData.thirdRowText;
  thirdHeaderRow.getCell(1).font = { bold: true, name: 'SansSerif',size:12};
  thirdHeaderRow.getCell(1).alignment = { horizontal: 'center',vertical: 'middle',wrapText: true};
  thirdHeaderRow.height = 30;
  thirdHeaderRow.getCell(1).border = {
    top: { style: 'thin' },
    left: { style: 'thin' },
    bottom: { style: 'thin' },
    right: { style: 'thin' },
  };


  const applyHeaderCellStyle = (cell) => {
    cell.font = { bold: true, name: 'SansSerif', size: 10 };
    cell.alignment = { horizontal: 'center', vertical: 'middle', wrapText: true };
    cell.border = {
      top: { style: 'thin' },
      left: { style: 'thin' },
      bottom: { style: 'thin' },
      right: { style: 'thin' },
    };
  };

  let headerRow1;
  let headerRow2;
  let headerRow3;
  let totalsColEnd = 21;

  if (is2023) {
    totalsColEnd = 36;
    headerRow1 = worksheet.addRow([
      'उत्तर प्रदेश',
      '',
      '',
      'मूल्य हज़ार रुपए तथा अन्य संख्या में ',
      ...Array(32).fill(''),
    ]);
    headerRow1.height = 20;
    headerRow1.eachCell((cell) => {
      cell.font = { bold: true, name: 'Calibri', size: 11 };
      applyHeaderCellStyle(cell);
    });
    worksheet.mergeCells('A4:C4');
    worksheet.mergeCells('D4:AJ4');
    worksheet.getCell('A4').value = 'उत्तर प्रदेश';
    worksheet.getCell('D4').value = 'मूल्य हज़ार रुपए तथा अन्य संख्या में ';

    headerRow2 = worksheet.addRow([
      'मण्डल',
      'जनपद',
      'उद्योग संकेत\n(4 अंकीय )\n(एन.आई.सी. 2008 )',
      'कारखानों की संख्या',
      '',
      '',
      'स्थायी पूँजी',
      'भौतिक कार्यशील पूँजी',
      'कार्यशील पूँजी',
      'निवेशित पूँजी',
      'स्थायी पूँजी में वृद्धि का सकल मूल्य',
      'किराया देय',
      'अदेय ऋण',
      'देय ब्याज',
      'प्राप्त किराया',
      'प्राप्त ब्याज',
      'संयंत्र एवं मशीनरी का सकल मूल्य',
      'उत्पाद एवं उप-उत्पादों का मूल्य',
      'अन्य उत्पादन',
      'कुल उत्पादन',
      'ईंधन की खपत',
      'विनिर्माण हेतु खप्त सामग्री',
      'अन्य निवेश',
      'कुल निवेश',
      'सकल आवर्धित मूल्य',
      'मूल्य ह्रास',
      'शुद्ध आवर्धित मूल्य',
      'शुद्ध स्थायी पूँजी निर्माण',
      'सकल स्थायी पूँजी निर्माण',
      'सामग्री, ईंधन आदि',
      'अर्ध निर्मित वस्तुएँ',
      'तैयार माल',
      'योग',
      'सकल पूँजी निर्माण',
      'शुद्ध आय',
      'लाभ',
    ]);
    headerRow2.height = 35;
    headerRow2.eachCell(applyHeaderCellStyle);

    headerRow3 = worksheet.addRow([
      '',
      '',
      '',
      'पंजीकृत',
      'कार्यरत',
      'अनुमानित',
      ...Array(30).fill(''),
    ]);
    headerRow3.height = 20;
    headerRow3.eachCell(applyHeaderCellStyle);

    worksheet.mergeCells('A5:A6');
    worksheet.mergeCells('B5:B6');
    worksheet.mergeCells('C5:C6');
    worksheet.mergeCells('D5:F5');
    const mergeColsTable2_2023 = [
      'G', 'H', 'I', 'J', 'K', 'L', 'M', 'N', 'O', 'P', 'Q', 'R', 'S', 'T', 'U', 'V', 'W', 'X', 'Y', 'Z',
      'AA', 'AB', 'AC', 'AD', 'AE', 'AF', 'AG', 'AH', 'AI', 'AJ',
    ];
    mergeColsTable2_2023.forEach((col) => {
      worksheet.mergeCells(`${col}5:${col}6`);
    });
  } else {
    headerRow1 = worksheet.addRow([
      'उत्तर प्रदेश', '', '','मूल्य हज़ार रुपए तथा अन्य संख्या में ','','','','','','','','','','','','','','','','',''
    ]);
    headerRow1.height = 20;
    headerRow1.eachCell(applyHeaderCellStyle);

    worksheet.mergeCells('A4:C4');
    worksheet.mergeCells('D4:U4');

    headerRow2 = worksheet.addRow([
      'मण्डल', 'जनपद','उद्योग संकेत\n(4 अंकीय )\n(एन.आई.सी. 2008 )','कारखानों की संख्या ','','', 'स्थायी पूँजी ','भौतिक कार्यशील पूँजी','विनियोजित  पूँजी','उपभुक्त सामग्री',
      'कुल आगत','कुल निर्गत','उत्पादन का मूल्य','सकल आवर्धित मूल्य','मूल्य ह्रास','शुद्ध आवर्धित मूल्य','शुद्ध स्थायी पूँजी विनिर्माण','सकल  स्थायी पूँजी विनिर्माण',
      'शुद्ध आय','लाभ','सकल पूँजी निर्माण'
    ]);
    headerRow2.height = 35;
    headerRow2.eachCell(applyHeaderCellStyle);
    worksheet.mergeCells('D5:F5');

    headerRow3 = worksheet.addRow([
      '','','','पंजीकृत','कार्यरत','अनुमानित','','','','','','','','','','','','','','',''
    ]);
    headerRow3.height = 20;
    headerRow3.eachCell(applyHeaderCellStyle);

    worksheet.mergeCells('A5:A6');
    worksheet.mergeCells('B5:B6');
    worksheet.mergeCells('C5:C6');
    worksheet.mergeCells('G5:G6');
    worksheet.mergeCells('H5:H6');
    worksheet.mergeCells('I5:I6');
    worksheet.mergeCells('J5:J6');
    worksheet.mergeCells('K5:K6');
    worksheet.mergeCells('L5:L6');
    worksheet.mergeCells('M5:M6');
    worksheet.mergeCells('N5:N6');
    worksheet.mergeCells('O5:O6');
    worksheet.mergeCells('P5:P6');
    worksheet.mergeCells('Q5:Q6');
    worksheet.mergeCells('R5:R6');
    worksheet.mergeCells('S5:S6');
    worksheet.mergeCells('T5:T6');
    worksheet.mergeCells('U5:U6');
  }

  headerRow1.eachCell((cell, colNumber) => {
    worksheet.getColumn(colNumber).width = 15;
  });
  headerRow2.eachCell((cell, colNumber) => {
    worksheet.getColumn(colNumber).width = 15;
  });
  headerRow3.eachCell((cell, colNumber) => {
    worksheet.getColumn(colNumber).width = 15;
  });

    excelObjectData.excelRowData.forEach((row) => {  //Excel Data Loop
      const dataRow = worksheet.addRow(row);
      dataRow.height=null;
      let isTotalRow = false;
      row.forEach((value, index) => {
        const cell = dataRow.getCell(index + 1);
        cell.font = {  name: 'SansSerif',size:10 };
        cell.alignment = { horizontal: 'center',vertical: 'middle',wrapText: true };
        cell.border = {
          top: { style: 'thin' },
          left: { style: 'thin' },
          bottom: { style: 'thin' },
          right: { style: 'thin' },
        };
        if (value === 'TOTAL') {
          isTotalRow = true;
        }
        // Customize styling for the cells if needed
      });

      if (isTotalRow) {
        dataRow.eachCell({ includeEmpty: true }, (cell) => {
          cell.font = { name: 'SansSerif', size: 12, bold: true };
        });
      }
    });
const totalsRow = worksheet.addRow([]); // Add a new row for totals

    for (let col = 4; col <= totalsColEnd; col++) {
      let total = 0;
    
      for (let row = 6; row < excelObjectData.excelRowData.length + 6; row++) {
        const value = worksheet.getCell(row + 1, col).value; // row + 1 because ExcelJS rows are 1-based
        const numValue = parseFloat(value); // Convert value to number
        if (!isNaN(numValue)) {
          total += numValue;
        }
      }
    
      // Set the computed total in the totals row
      const totalCell = totalsRow.getCell(col);
      totalCell.value = total;
      totalCell.font = { name: 'SansSerif', size: 10, bold: true };
      totalCell.alignment = { horizontal: 'center', vertical: 'middle', wrapText: true };
      totalCell.border = {
        top: { style: 'thin' },
        left: { style: 'thin' },
        bottom: { style: 'thin' },
        right: { style: 'thin' },
      };
    }
    
    // Optionally set row height for the totals row
    totalsRow.height = 20;
    
    // Adjust column widths to fit the content
    for (let col = 4; col <= totalsColEnd; col++) {
      worksheet.getColumn(col).eachCell({ includeEmpty: true }, (cell) => {
        worksheet.getColumn(col).width = Math.max(worksheet.getColumn(col).width, cell.value ? cell.value.toString().length + 2 : 10);
      });
    }

    worksheet.columns.forEach((column) => {
      column.width = 15;
    });
    
    const buffer = await workbook.xlsx.writeBuffer();
    const blob = new Blob([buffer], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=UTF-8' });
    const fileName=`${excelObjectData.fileName}.${excelObjectData.fileType}`;
    FileSaver.saveAs(blob, fileName);
};


export const generateExcelASITable3 = async (excelObjectData) => {

  const workbook = new ExcelJS.Workbook();
  const worksheet = workbook.addWorksheet(excelObjectData.sheetName);

  //First Row Design and Merge cells A1:O1
  worksheet.mergeCells(excelObjectData.firstRowMergeCells);
  const firstHeaderRow = worksheet.getRow(1);
  firstHeaderRow.getCell(1).value = excelObjectData.firstRowExportData
  firstHeaderRow.getCell(1).font = { name: 'SansSerif',size:20};
  firstHeaderRow.getCell(1).alignment = { horizontal: 'center',vertical: 'middle',wrapText: true };
  firstHeaderRow.height = 30;
 
  
  //Second Row Design and  Merge cells A2:O2
  worksheet.mergeCells(excelObjectData.secondRowMergeCells); 
  const secondHeaderRow = worksheet.getRow(2);
  secondHeaderRow.getCell(1).value = excelObjectData.secondRowText;
  secondHeaderRow.getCell(1).font = { bold: true, name: 'SansSerif',size:12};
  secondHeaderRow.getCell(1).alignment = { horizontal: 'center',vertical: 'middle',wrapText: true};
  secondHeaderRow.height = 30;
  secondHeaderRow.getCell(1).border = {
    top: { style: 'thin' },
    left: { style: 'thin' },
    bottom: { style: 'thin' },
    right: { style: 'thin' },
  };


  
// Third Row Design and  Merge cells A3:O3

  worksheet.mergeCells(excelObjectData.thirdRowMergeCells); 
  const thirdHeaderRow = worksheet.getRow(3);
  thirdHeaderRow.getCell(1).value = excelObjectData.thirdRowText;
  thirdHeaderRow.getCell(1).font = { bold: true, name: 'SansSerif',size:12};
  thirdHeaderRow.getCell(1).alignment = { horizontal: 'center',vertical: 'middle',wrapText: true};
  thirdHeaderRow.height = 30;
  thirdHeaderRow.getCell(1).border = {
    top: { style: 'thin' },
    left: { style: 'thin' },
    bottom: { style: 'thin' },
    right: { style: 'thin' },
  };

    const headerRow1 = worksheet.addRow([
      'उत्तर प्रदेश', 'मूल्य हज़ार रुपए तथा अन्य संख्या में ', '','','','','','','','',''
    ]);
    headerRow1.height = 20;
    headerRow1.eachCell((cell, colNumber) => {
      cell.font = { bold: true, name: 'SansSerif', size: 10 };
      cell.alignment = { horizontal: 'center', vertical: 'middle', wrapText: true };
      cell.border = {
        top: { style: 'thin' },
        left: { style: 'thin' },
        bottom: { style: 'thin' },
        right: { style: 'thin' },
      };
    });
  
    worksheet.mergeCells('B4:K4');
  
    // Create the second row of headers (individual columns under year ranges)
    const headerRow2 = worksheet.addRow([
      'उद्योग संकेत\n(4 अंकीय )\n(एन.आई.सी. 2008 )', 'कारखानों की संख्या ','','', ' श्रम दिवस ',' कर्मी ',' पर्यवेक्षीय एवं प्रबंधकीय कर्मचारी वर्ग ',' अन्य कर्मचारी ',
      ' समस्त कर्मचारी ','कुल परिलब्धियां (मजदूरी /वेतन ,हितलाभ आदि )','',
    ]);
    headerRow2.height = 35;
    headerRow2.eachCell((cell, colNumber) => {
      cell.font = { bold: true, name: 'SansSerif', size: 10 };
      cell.alignment = { horizontal: 'center', vertical: 'middle', wrapText: true };
      cell.border = {
        top: { style: 'thin' },
        left: { style: 'thin' },
        bottom: { style: 'thin' },
        right: { style: 'thin' },
      };
    });
    worksheet.mergeCells('B5:D5');
    worksheet.mergeCells('J5:K5');

    const headerRow3 = worksheet.addRow([
      '','पंजीकृत','कार्यरत','अनुमानित','','','','','','कर्मी ','समस्त कर्मचारी',
    ]);
    headerRow3.height = 20;
    headerRow3.eachCell((cell, colNumber) => {
      cell.font = { bold: true, name: 'SansSerif', size: 10 };
      cell.alignment = { horizontal: 'center', vertical: 'middle', wrapText: true };
      cell.border = {
        top: { style: 'thin' },
        left: { style: 'thin' },
        bottom: { style: 'thin' },
        right: { style: 'thin' },
      };
    });


    worksheet.mergeCells('A5:A6');
    worksheet.mergeCells('E5:E6');
    worksheet.mergeCells('F5:F6');
    worksheet.mergeCells('G5:G6');
    worksheet.mergeCells('H5:H6');
    worksheet.mergeCells('I5:I6');

    headerRow1.eachCell((cell, colNumber) => {
      worksheet.getColumn(colNumber).width = 15;
    });
    headerRow2.eachCell((cell, colNumber) => {
      worksheet.getColumn(colNumber).width = 15;
    });
    headerRow3.eachCell((cell, colNumber) => {
      worksheet.getColumn(colNumber).width = 15;
    });

    excelObjectData.excelRowData.forEach((row) => { 
      const dataRow = worksheet.addRow(row);
      dataRow.height=null;
      let isTotalRow = false;
      row.forEach((value, index) => {
        const cell = dataRow.getCell(index + 1);
        cell.font = {  name: 'SansSerif',size:10 };
        cell.alignment = { horizontal: 'center',vertical: 'middle',wrapText: true };
        cell.border = {
          top: { style: 'thin' },
          left: { style: 'thin' },
          bottom: { style: 'thin' },
          right: { style: 'thin' },
        };
        if (value === 'TOTAL') {
          isTotalRow = true;
        }
        // Customize styling for the cells if needed
      });

      if (isTotalRow) {
        dataRow.eachCell({ includeEmpty: true }, (cell) => {
          cell.font = { name: 'SansSerif', size: 12, bold: true };
        });
      }
    });

    const totalsRow = worksheet.addRow([]); // Add a new row for totals

    for (let col = 2; col <= 11; col++) { // Assuming columns B to S (2 to 19)
      let total = 0;
    
      // Sum up all numerical values in the column
      for (let row = 6; row < excelObjectData.excelRowData.length+6; row++) {
        const value = worksheet.getCell(row + 1, col).value; // row + 1 because ExcelJS rows are 1-based
        if (!isNaN(value)) {
          total += parseFloat(value);
        }
      }
    
      // Set the computed total in the totals row
      const totalCell = totalsRow.getCell(col);
      totalCell.value = total;
      totalCell.font = { name: 'SansSerif', size: 10, bold: true };
      totalCell.alignment = { horizontal: 'center', vertical: 'middle', wrapText: true };
      totalCell.border = {
        top: { style: 'thin' },
        left: { style: 'thin' },
        bottom: { style: 'thin' },
        right: { style: 'thin' },
      };
    }
    
    // Optionally set row height for the totals row
    totalsRow.height = 20;
    
    // Adjust column widths to fit the content
    for (let col = 1; col <= 11; col++) { // Adjusting widths for all columns B to S
      worksheet.getColumn(col).eachCell({ includeEmpty: true }, (cell) => {
        worksheet.getColumn(col).width = Math.max(worksheet.getColumn(col).width, cell.value ? cell.value.toString().length + 2 : 10);
      });
    }

    worksheet.columns.forEach((column) => {
      column.width = 15;
    });

    const buffer = await workbook.xlsx.writeBuffer();
    const blob = new Blob([buffer], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=UTF-8' });
    const fileName=`${excelObjectData.fileName}.${excelObjectData.fileType}`;
    FileSaver.saveAs(blob, fileName);
};


export const generateExcelASITable4 = async (excelObjectData) => {

  const workbook = new ExcelJS.Workbook();
  const worksheet = workbook.addWorksheet(excelObjectData.sheetName);

  //First Row Design and Merge cells A1:M1
  worksheet.mergeCells(excelObjectData.firstRowMergeCells);
  const firstHeaderRow = worksheet.getRow(1);
  firstHeaderRow.getCell(1).value = excelObjectData.firstRowExportData
  firstHeaderRow.getCell(1).font = { name: 'SansSerif',size:20};
  firstHeaderRow.getCell(1).alignment = { horizontal: 'center',vertical: 'middle',wrapText: true };
  firstHeaderRow.height = 30;
 
  
  //Second Row Design and  Merge cells A2:M2
  worksheet.mergeCells(excelObjectData.secondRowMergeCells); 
  const secondHeaderRow = worksheet.getRow(2);
  secondHeaderRow.getCell(1).value = excelObjectData.secondRowText;
  secondHeaderRow.getCell(1).font = { bold: true, name: 'SansSerif',size:12};
  secondHeaderRow.getCell(1).alignment = { horizontal: 'center',vertical: 'middle',wrapText: true};
  secondHeaderRow.height = 30;
  secondHeaderRow.getCell(1).border = {
    top: { style: 'thin' },
    left: { style: 'thin' },
    bottom: { style: 'thin' },
    right: { style: 'thin' },
  };


  
// Third Row Design and  Merge cells A3:M3

  worksheet.mergeCells(excelObjectData.thirdRowMergeCells); 
  const thirdHeaderRow = worksheet.getRow(3);
  thirdHeaderRow.getCell(1).value = excelObjectData.thirdRowText;
  thirdHeaderRow.getCell(1).font = { bold: true, name: 'SansSerif',size:12};
  thirdHeaderRow.getCell(1).alignment = { horizontal: 'center',vertical: 'middle',wrapText: true};
  thirdHeaderRow.height = 30;
  thirdHeaderRow.getCell(1).border = {
    top: { style: 'thin' },
    left: { style: 'thin' },
    bottom: { style: 'thin' },
    right: { style: 'thin' },
  };

    const headerRow1 = worksheet.addRow([
      'उत्तर प्रदेश','','', 'मूल्य हज़ार रुपए तथा अन्य संख्या में ', '','','','','','','','',''
    ]);
    headerRow1.height = 20;
    headerRow1.eachCell((cell, colNumber) => {
      cell.font = { bold: true, name: 'SansSerif', size: 10 };
      cell.alignment = { horizontal: 'center', vertical: 'middle', wrapText: true };
      cell.border = {
        top: { style: 'thin' },
        left: { style: 'thin' },
        bottom: { style: 'thin' },
        right: { style: 'thin' },
      };
    });
  
    worksheet.mergeCells('A4:C4');
    worksheet.mergeCells('D4:M4');
  
    // Create the second row of headers (individual columns under year ranges)
    const headerRow2 = worksheet.addRow([
      'मण्डल','जनपद','उद्योग संकेत\n(4 अंकीय )\n(एन.आई.सी. 2008 )', 'कारखानों की संख्या ','','', ' श्रम दिवस ',' कर्मी ',' पर्यवेक्षीय एवं प्रबंधकीय कर्मचारी वर्ग ',' अन्य कर्मचारी ',
      ' समस्त कर्मचारी ','कुल परिलब्धियां (मजदूरी /वेतन ,हितलाभ आदि )'
    ]);
    headerRow2.height = 35;
    headerRow2.eachCell((cell, colNumber) => {
      cell.font = { bold: true, name: 'SansSerif', size: 10 };
      cell.alignment = { horizontal: 'center', vertical: 'middle', wrapText: true };
      cell.border = {
        top: { style: 'thin' },
        left: { style: 'thin' },
        bottom: { style: 'thin' },
        right: { style: 'thin' },
      };
    });
    worksheet.mergeCells('D5:F5');
    worksheet.mergeCells('L5:M5');

    const headerRow3 = worksheet.addRow([
      '','','','पंजीकृत','कार्यरत','अनुमानित','','','','','','कर्मी ','समस्त कर्मचारी',
    ]);
    headerRow3.height = 20;
    headerRow3.eachCell((cell, colNumber) => {
      cell.font = { bold: true, name: 'SansSerif', size: 10 };
      cell.alignment = { horizontal: 'center', vertical: 'middle', wrapText: true };
      cell.border = {
        top: { style: 'thin' },
        left: { style: 'thin' },
        bottom: { style: 'thin' },
        right: { style: 'thin' },
      };
    });


    worksheet.mergeCells('A5:A6');
    worksheet.mergeCells('B5:B6');
    worksheet.mergeCells('C5:C6');
    worksheet.mergeCells('G5:G6');
    worksheet.mergeCells('H5:H6');
    worksheet.mergeCells('I5:I6');
    worksheet.mergeCells('J5:J6');
    worksheet.mergeCells('K5:K6');

    headerRow1.eachCell((cell, colNumber) => {
      worksheet.getColumn(colNumber).width = 15;
    });
    headerRow2.eachCell((cell, colNumber) => {
      worksheet.getColumn(colNumber).width = 15;
    });
    headerRow3.eachCell((cell, colNumber) => {
      worksheet.getColumn(colNumber).width = 15;
    });

    excelObjectData.excelRowData.forEach((row) => { 
      const dataRow = worksheet.addRow(row);
      dataRow.height=null;
      let isTotalRow = false;
      row.forEach((value, index) => {
        const cell = dataRow.getCell(index + 1);
        cell.font = {  name: 'SansSerif',size:10 };
        cell.alignment = { horizontal: 'center',vertical: 'middle',wrapText: true };
        cell.border = {
          top: { style: 'thin' },
          left: { style: 'thin' },
          bottom: { style: 'thin' },
          right: { style: 'thin' },
        };
        if (value === 'TOTAL') {
          isTotalRow = true;
        }
        // Customize styling for the cells if needed
      });

      if (isTotalRow) {
        dataRow.eachCell({ includeEmpty: true }, (cell) => {
          cell.font = { name: 'SansSerif', size: 12, bold: true };
        });
      }
    });

    const totalsRow = worksheet.addRow([]); // Add a new row for totals

    for (let col = 4; col <= 13; col++) { // Assuming columns B to S (2 to 19)
      let total = 0;
    
      // Sum up all numerical values in the column
      for (let row = 6; row < excelObjectData.excelRowData.length+6; row++) {
        const value = worksheet.getCell(row + 1, col).value; // row + 1 because ExcelJS rows are 1-based
        if (!isNaN(value)) {
          total += parseFloat(value);
        }
      }
    
      // Set the computed total in the totals row
      const totalCell = totalsRow.getCell(col);
      totalCell.value = total;
      totalCell.font = { name: 'SansSerif', size: 10, bold: true };
      totalCell.alignment = { horizontal: 'center', vertical: 'middle', wrapText: true };
      totalCell.border = {
        top: { style: 'thin' },
        left: { style: 'thin' },
        bottom: { style: 'thin' },
        right: { style: 'thin' },
      };
    }
    
    // Optionally set row height for the totals row
    totalsRow.height = 20;
    
    // Adjust column widths to fit the content
    for (let col = 1; col <= 11; col++) { // Adjusting widths for all columns B to S
      worksheet.getColumn(col).eachCell({ includeEmpty: true }, (cell) => {
        worksheet.getColumn(col).width = Math.max(worksheet.getColumn(col).width, cell.value ? cell.value.toString().length + 2 : 10);
      });
    }

    worksheet.columns.forEach((column) => {
      column.width = 15;
    });

    const buffer = await workbook.xlsx.writeBuffer();
    const blob = new Blob([buffer], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=UTF-8' });
    const fileName=`${excelObjectData.fileName}.${excelObjectData.fileType}`;
    FileSaver.saveAs(blob, fileName);
};


export const generateExcelASITable5 = async (excelObjectData) => {

  const workbook = new ExcelJS.Workbook();
  const worksheet = workbook.addWorksheet(excelObjectData.sheetName);

  //First Row Design and Merge cells A1:M1
  worksheet.mergeCells(excelObjectData.firstRowMergeCells);
  const firstHeaderRow = worksheet.getRow(1);
  firstHeaderRow.getCell(1).value = excelObjectData.firstRowExportData
  firstHeaderRow.getCell(1).font = { name: 'SansSerif',size:20};
  firstHeaderRow.getCell(1).alignment = { horizontal: 'center',vertical: 'middle',wrapText: true };
  firstHeaderRow.height = 30;
 
  
  //Second Row Design and  Merge cells A2:M2
  worksheet.mergeCells(excelObjectData.secondRowMergeCells); 
  const secondHeaderRow = worksheet.getRow(2);
  secondHeaderRow.getCell(1).value = excelObjectData.secondRowText;
  secondHeaderRow.getCell(1).font = { bold: true, name: 'SansSerif',size:12};
  secondHeaderRow.getCell(1).alignment = { horizontal: 'center',vertical: 'middle',wrapText: true};
  secondHeaderRow.height = 30;
  secondHeaderRow.getCell(1).border = {
    top: { style: 'thin' },
    left: { style: 'thin' },
    bottom: { style: 'thin' },
    right: { style: 'thin' },
  };


  
// Third Row Design and  Merge cells A3:M3

  worksheet.mergeCells(excelObjectData.thirdRowMergeCells); 
  const thirdHeaderRow = worksheet.getRow(3);
  thirdHeaderRow.getCell(1).value = excelObjectData.thirdRowText;
  thirdHeaderRow.getCell(1).font = { bold: true, name: 'SansSerif',size:12};
  thirdHeaderRow.getCell(1).alignment = { horizontal: 'center',vertical: 'middle',wrapText: true};
  thirdHeaderRow.height = 30;
  thirdHeaderRow.getCell(1).border = {
    top: { style: 'thin' },
    left: { style: 'thin' },
    bottom: { style: 'thin' },
    right: { style: 'thin' },
  };

    const headerRow1 = worksheet.addRow([
      'उत्तर प्रदेश','मूल्य हज़ार रुपए तथा अन्य संख्या में ', '','','','','','',''
    ]);
    headerRow1.height = 20;
    headerRow1.eachCell((cell, colNumber) => {
      cell.font = { bold: true, name: 'SansSerif', size: 10 };
      cell.alignment = { horizontal: 'center', vertical: 'middle', wrapText: true };
      cell.border = {
        top: { style: 'thin' },
        left: { style: 'thin' },
        bottom: { style: 'thin' },
        right: { style: 'thin' },
      };
    });
  

    worksheet.mergeCells('B4:I4');
  
    // Create the second row of headers (individual columns under year ranges)
    const headerRow2 = worksheet.addRow([
    'उद्योग संकेत\n(3 अंकीय )\n(एन.आई.सी. 2008 )', 'कोयला','','विद्द्युत क्रय', '',' पेट्रोलियम\nउत्पाद','गैस','अन्य ईंधन','कुल मूल्य'
      
    ]);
    headerRow2.height = 35;
    headerRow2.eachCell((cell, colNumber) => {
      cell.font = { bold: true, name: 'SansSerif', size: 10 };
      cell.alignment = { horizontal: 'center', vertical: 'middle', wrapText: true };
      cell.border = {
        top: { style: 'thin' },
        left: { style: 'thin' },
        bottom: { style: 'thin' },
        right: { style: 'thin' },
      };
    });

    worksheet.mergeCells('B5:C5');
    worksheet.mergeCells('D5:E5');
    

    const headerRow3 = worksheet.addRow([
    '','मात्रा','मूल्य','मात्रा','मूल्य ','','','',''
    ]);
    headerRow3.height = 20;
    headerRow3.eachCell((cell, colNumber) => {
      cell.font = { bold: true, name: 'SansSerif', size: 10 };
      cell.alignment = { horizontal: 'center', vertical: 'middle', wrapText: true };
      cell.border = {
        top: { style: 'thin' },
        left: { style: 'thin' },
        bottom: { style: 'thin' },
        right: { style: 'thin' },
      };
    });


    worksheet.mergeCells('A5:A6');
    worksheet.mergeCells('F5:F6');
    worksheet.mergeCells('G5:G6');
    worksheet.mergeCells('H5:H6');
    worksheet.mergeCells('I5:I6');

    headerRow1.eachCell((cell, colNumber) => {
      worksheet.getColumn(colNumber).width = 15;
    });
    headerRow2.eachCell((cell, colNumber) => {
      worksheet.getColumn(colNumber).width = 15;
    });
    headerRow3.eachCell((cell, colNumber) => {
      worksheet.getColumn(colNumber).width = 15;
    });

    excelObjectData.excelRowData.forEach((row) => { 
      const dataRow = worksheet.addRow(row);
      dataRow.height=null;
      let isTotalRow = false;
      row.forEach((value, index) => {
        const cell = dataRow.getCell(index + 1);
        cell.font = {  name: 'SansSerif',size:10 };
        cell.alignment = { horizontal: 'center',vertical: 'middle',wrapText: true };
        cell.border = {
          top: { style: 'thin' },
          left: { style: 'thin' },
          bottom: { style: 'thin' },
          right: { style: 'thin' },
        };
        if (value === 'TOTAL') {
          isTotalRow = true;
        }
        // Customize styling for the cells if needed
      });

      if (isTotalRow) {
        dataRow.eachCell({ includeEmpty: true }, (cell) => {
          cell.font = { name: 'SansSerif', size: 12, bold: true };
        });
      }
    });

    const totalsRow = worksheet.addRow([]); // Add a new row for totals

    for (let col = 2; col <= 9; col++) { // Assuming columns B to S (2 to 19)
      let total = 0;
    
      // Sum up all numerical values in the column
      for (let row = 6; row < excelObjectData.excelRowData.length+6; row++) {
        const value = worksheet.getCell(row + 1, col).value; // row + 1 because ExcelJS rows are 1-based
        if (!isNaN(value)) {
          total += parseFloat(value);
        }
      }
    
      // Set the computed total in the totals row
      const totalCell = totalsRow.getCell(col);
      totalCell.value = total;
      totalCell.font = { name: 'SansSerif', size: 10, bold: true };
      totalCell.alignment = { horizontal: 'center', vertical: 'middle', wrapText: true };
      totalCell.border = {
        top: { style: 'thin' },
        left: { style: 'thin' },
        bottom: { style: 'thin' },
        right: { style: 'thin' },
      };
    }
    
    // Optionally set row height for the totals row
    totalsRow.height = 20;
    
    // Adjust column widths to fit the content
    for (let col = 1; col <= 11; col++) { // Adjusting widths for all columns B to S
      worksheet.getColumn(col).eachCell({ includeEmpty: true }, (cell) => {
        worksheet.getColumn(col).width = Math.max(worksheet.getColumn(col).width, cell.value ? cell.value.toString().length + 2 : 10);
      });
    }

    worksheet.columns.forEach((column) => {
      column.width = 15;
    });

    const buffer = await workbook.xlsx.writeBuffer();
    const blob = new Blob([buffer], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=UTF-8' });
    const fileName=`${excelObjectData.fileName}.${excelObjectData.fileType}`;
    FileSaver.saveAs(blob, fileName);
};


export const generateExcelASITable6 = async (excelObjectData) => {

  const workbook = new ExcelJS.Workbook();
  const worksheet = workbook.addWorksheet(excelObjectData.sheetName);

  //First Row Design and Merge cells A1:M1
  worksheet.mergeCells(excelObjectData.firstRowMergeCells);
  const firstHeaderRow = worksheet.getRow(1);
  firstHeaderRow.getCell(1).value = excelObjectData.firstRowExportData
  firstHeaderRow.getCell(1).font = { name: 'SansSerif',size:20};
  firstHeaderRow.getCell(1).alignment = { horizontal: 'center',vertical: 'middle',wrapText: true };
  firstHeaderRow.height = 30;
 
  
  //Second Row Design and  Merge cells A2:M2
  worksheet.mergeCells(excelObjectData.secondRowMergeCells); 
  const secondHeaderRow = worksheet.getRow(2);
  secondHeaderRow.getCell(1).value = excelObjectData.secondRowText;
  secondHeaderRow.getCell(1).font = { bold: true, name: 'SansSerif',size:12};
  secondHeaderRow.getCell(1).alignment = { horizontal: 'center',vertical: 'middle',wrapText: true};
  secondHeaderRow.height = 30;
  secondHeaderRow.getCell(1).border = {
    top: { style: 'thin' },
    left: { style: 'thin' },
    bottom: { style: 'thin' },
    right: { style: 'thin' },
  };


  
// Third Row Design and  Merge cells A3:M3

  worksheet.mergeCells(excelObjectData.thirdRowMergeCells); 
  const thirdHeaderRow = worksheet.getRow(3);
  thirdHeaderRow.getCell(1).value = excelObjectData.thirdRowText;
  thirdHeaderRow.getCell(1).font = { bold: true, name: 'SansSerif',size:12};
  thirdHeaderRow.getCell(1).alignment = { horizontal: 'center',vertical: 'middle',wrapText: true};
  thirdHeaderRow.height = 30;
  thirdHeaderRow.getCell(1).border = {
    top: { style: 'thin' },
    left: { style: 'thin' },
    bottom: { style: 'thin' },
    right: { style: 'thin' },
  };

    const headerRow1 = worksheet.addRow([
      'उत्तर प्रदेश','','', 'मूल्य हज़ार रुपए तथा अन्य संख्या में ', '','','','','','',''
    ]);
    headerRow1.height = 20;
    headerRow1.eachCell((cell, colNumber) => {
      cell.font = { bold: true, name: 'SansSerif', size: 10 };
      cell.alignment = { horizontal: 'center', vertical: 'middle', wrapText: true };
      cell.border = {
        top: { style: 'thin' },
        left: { style: 'thin' },
        bottom: { style: 'thin' },
        right: { style: 'thin' },
      };
    });
  
    worksheet.mergeCells('A4:C4');
    worksheet.mergeCells('D4:K4');
  
    // Create the second row of headers (individual columns under year ranges)
    const headerRow2 = worksheet.addRow([
      'मण्डल','जनपद','उद्योग संकेत\n(4 अंकीय )\n(एन.आई.सी. 2008 )', 'कोयला','','विद्द्युत क्रय', '',' पेट्रोलियम\nउत्पाद','गैस','अन्य ईंधन','कुल मूल्य'
      
    ]);
    headerRow2.height = 35;
    headerRow2.eachCell((cell, colNumber) => {
      cell.font = { bold: true, name: 'SansSerif', size: 10 };
      cell.alignment = { horizontal: 'center', vertical: 'middle', wrapText: true };
      cell.border = {
        top: { style: 'thin' },
        left: { style: 'thin' },
        bottom: { style: 'thin' },
        right: { style: 'thin' },
      };
    });
    worksheet.mergeCells('D5:E5');
    worksheet.mergeCells('F5:G5');

    const headerRow3 = worksheet.addRow([
      '','','','मात्रा','मूल्य','मात्रा','मूल्य ','','','',''
    ]);
    headerRow3.height = 20;
    headerRow3.eachCell((cell, colNumber) => {
      cell.font = { bold: true, name: 'SansSerif', size: 10 };
      cell.alignment = { horizontal: 'center', vertical: 'middle', wrapText: true };
      cell.border = {
        top: { style: 'thin' },
        left: { style: 'thin' },
        bottom: { style: 'thin' },
        right: { style: 'thin' },
      };
    });


    worksheet.mergeCells('A5:A6');
    worksheet.mergeCells('B5:B6');
    worksheet.mergeCells('C5:C6');
    worksheet.mergeCells('H5:H6');
    worksheet.mergeCells('I5:I6');
    worksheet.mergeCells('J5:J6');
    worksheet.mergeCells('K5:K6');

    headerRow1.eachCell((cell, colNumber) => {
      worksheet.getColumn(colNumber).width = 15;
    });
    headerRow2.eachCell((cell, colNumber) => {
      worksheet.getColumn(colNumber).width = 15;
    });
    headerRow3.eachCell((cell, colNumber) => {
      worksheet.getColumn(colNumber).width = 15;
    });

    excelObjectData.excelRowData.forEach((row) => { 
      const dataRow = worksheet.addRow(row);
      dataRow.height=null;
      let isTotalRow = false;
      row.forEach((value, index) => {
        const cell = dataRow.getCell(index + 1);
        cell.font = {  name: 'SansSerif',size:10 };
        cell.alignment = { horizontal: 'center',vertical: 'middle',wrapText: true };
        cell.border = {
          top: { style: 'thin' },
          left: { style: 'thin' },
          bottom: { style: 'thin' },
          right: { style: 'thin' },
        };
        if (value === 'TOTAL') {
          isTotalRow = true;
        }
        // Customize styling for the cells if needed
      });

      if (isTotalRow) {
        dataRow.eachCell({ includeEmpty: true }, (cell) => {
          cell.font = { name: 'SansSerif', size: 12, bold: true };
        });
      }
    });

    const totalsRow = worksheet.addRow([]); // Add a new row for totals

    for (let col = 4; col <= 11; col++) { // Assuming columns B to S (2 to 19)
      let total = 0;
    
      // Sum up all numerical values in the column
      for (let row = 1; row < excelObjectData.excelRowData.length; row++) {
        const value = worksheet.getCell(row + 1, col).value; // row + 1 because ExcelJS rows are 1-based
        if (!isNaN(value)) {
          total += parseFloat(value);
        }
      }
    
      // Set the computed total in the totals row
      const totalCell = totalsRow.getCell(col);
      totalCell.value = total;
      totalCell.font = { name: 'SansSerif', size: 10, bold: true };
      totalCell.alignment = { horizontal: 'center', vertical: 'middle', wrapText: true };
      totalCell.border = {
        top: { style: 'thin' },
        left: { style: 'thin' },
        bottom: { style: 'thin' },
        right: { style: 'thin' },
      };
    }
    
    // Optionally set row height for the totals row
    totalsRow.height = 20;
    
    // Adjust column widths to fit the content
    for (let col = 1; col <= 11; col++) { // Adjusting widths for all columns B to S
      worksheet.getColumn(col).eachCell({ includeEmpty: true }, (cell) => {
        worksheet.getColumn(col).width = Math.max(worksheet.getColumn(col).width, cell.value ? cell.value.toString().length + 2 : 10);
      });
    }

    worksheet.columns.forEach((column) => {
      column.width = 15;
    });

    const buffer = await workbook.xlsx.writeBuffer();
    const blob = new Blob([buffer], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=UTF-8' });
    const fileName=`${excelObjectData.fileName}.${excelObjectData.fileType}`;
    FileSaver.saveAs(blob, fileName);
};


export const generateExcelASITable7 = async (excelObjectData) => {

  const workbook = new ExcelJS.Workbook();
  const worksheet = workbook.addWorksheet(excelObjectData.sheetName);

  //First Row Design and Merge cells A1:M1
  worksheet.mergeCells(excelObjectData.firstRowMergeCells);
  const firstHeaderRow = worksheet.getRow(1);
  firstHeaderRow.getCell(1).value = excelObjectData.firstRowExportData
  firstHeaderRow.getCell(1).font = { name: 'SansSerif',size:20};
  firstHeaderRow.getCell(1).alignment = { horizontal: 'center',vertical: 'middle',wrapText: true };
  firstHeaderRow.height = 30;
 
  
  //Second Row Design and  Merge cells A2:M2
  worksheet.mergeCells(excelObjectData.secondRowMergeCells); 
  const secondHeaderRow = worksheet.getRow(2);
  secondHeaderRow.getCell(1).value = excelObjectData.secondRowText;
  secondHeaderRow.getCell(1).font = { bold: true, name: 'SansSerif',size:12};
  secondHeaderRow.getCell(1).alignment = { horizontal: 'center',vertical: 'middle',wrapText: true};
  secondHeaderRow.height = 30;
  secondHeaderRow.getCell(1).border = {
    top: { style: 'thin' },
    left: { style: 'thin' },
    bottom: { style: 'thin' },
    right: { style: 'thin' },
  };



  const headerRow1 = worksheet.addRow(excelObjectData.headerEnglishColumns);
  headerRow1.height=50;
  headerRow1.eachCell((cell,colNumber ) => {
    cell.font = { bold: true, name: 'SansSerif',size:10};
    cell.alignment = { horizontal: 'center',vertical: 'middle',wrapText: true };
    cell.value = breakTitle(cell.value);
    cell.border = {
      top: { style: 'thin' },
      left: { style: 'thin' },
      bottom: { style: 'thin' },
      right: { style: 'thin' },
    };
    const column = worksheet.getColumn(colNumber); 
   });


    excelObjectData.excelRowData.forEach((row) => { 
      const dataRow = worksheet.addRow(row);
      dataRow.height=null;
      let isTotalRow = false;
      row.forEach((value, index) => {
        const cell = dataRow.getCell(index + 1);
        cell.font = {  name: 'SansSerif',size:10 };
        cell.alignment = { horizontal: 'center',vertical: 'middle',wrapText: true };
        cell.border = {
          top: { style: 'thin' },
          left: { style: 'thin' },
          bottom: { style: 'thin' },
          right: { style: 'thin' },
        };
        if (value === 'TOTAL') {
          isTotalRow = true;
        }
        // Customize styling for the cells if needed
      });

      if (isTotalRow) {
        dataRow.eachCell({ includeEmpty: true }, (cell) => {
          cell.font = { name: 'SansSerif', size: 12, bold: true };
        });
      }
    });

    worksheet.columns.forEach((column) => {
      column.width = 15;
    });

    const buffer = await workbook.xlsx.writeBuffer();
    const blob = new Blob([buffer], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=UTF-8' });
    const fileName=`${excelObjectData.fileName}.${excelObjectData.fileType}`;
    FileSaver.saveAs(blob, fileName);
};



// Multiplier Report 
export const generateMultiplierReport = async (excelObjectData) => {

  const workbook = new ExcelJS.Workbook();
  const worksheet = workbook.addWorksheet(excelObjectData.sheetName);

  //First Row Design and Merge cells A1:K1
  worksheet.mergeCells(excelObjectData.firstRowMergeCells);
  const firstHeaderRow = worksheet.getRow(1);
  firstHeaderRow.getCell(1).value = excelObjectData.firstRowExportDate
  firstHeaderRow.getCell(1).font = {name: 'SansSerif'};
  firstHeaderRow.getCell(1).alignment = { horizontal: 'right',vertical: 'middle',wrapText: true };
  firstHeaderRow.height = 15;
 
  
  //Second Row Design and  Merge cells A2:K2
  worksheet.mergeCells(excelObjectData.secondRowMergeCells); 
  const secondHeaderRow = worksheet.getRow(2);
  secondHeaderRow.getCell(1).value = excelObjectData.secondRowText;
  secondHeaderRow.getCell(1).font = {  bold: true,name: 'SansSerif',size:12};
  secondHeaderRow.getCell(1).alignment = { horizontal: 'center',vertical: 'middle',wrapText: true};
  secondHeaderRow.height = 20;
  secondHeaderRow.getCell(1).border = {
    top: { style: 'thin' },
    left: { style: 'thin' },
    bottom: { style: 'thin' },
    right: { style: 'thin' },
  };




  const headerRow3 = worksheet.addRow([
    'District code',
    'Industry code (NIC 3-digit)', 
    'No of all units in Frame    (census + sample sector)',
    'No of all units in Census sector',
    'No.of sample Sector units in the Frame (col.3- col.4) (N)',
    'No.of selected Sample','',
    // 'Central Sample',
    // 'State Sample',
    'Total No.of units Selected in the  Sample Sector (col.6+ col.7) (n)',
    "Total No.of units Surveyed (n') (col.8-col.10)'",
    "Casualty Cases (Status Code 5, 7 & 8)",
    "Multiplier (col. 5 / col.9) N / n' (0.0000)"
]);
  headerRow3.height = 30;
  headerRow3.eachCell((cell, colNumber) => {
    cell.font = { bold: true, name: 'SansSerif', size: 10 };
    cell.alignment = { horizontal: 'center', vertical: 'middle', wrapText: true };
    cell.border = {
      top: { style: 'thin' },
      left: { style: 'thin' },
      bottom: { style: 'thin' },
      right: { style: 'thin' },
    };
     const column = worksheet.getColumn(colNumber);
      column.width = 15;
  });
  
  worksheet.mergeCells('F3:G3');


const headerRow4 = worksheet.addRow([ '', '', '', '','', 'Central Sample', 'State Sample',  '', '', '', ''
]);

    //excel English Column
      headerRow4.height=55;
      headerRow4.eachCell((cell,colNumber ) => {
      cell.font = { bold: true, name: 'SansSerif',size:10};
      cell.alignment = { horizontal: 'center',vertical: 'middle',wrapText: true };
      cell.value = breakTitle(cell.value);
      cell.border = {
        top: { style: 'thin' },
        left: { style: 'thin' },
        bottom: { style: 'thin' },
        right: { style: 'thin' },
        
      };
      const column = worksheet.getColumn(colNumber);
      column.width = 15;
        
     });
    worksheet.mergeCells('A3:A4');
    worksheet.mergeCells('B3:B4');
    worksheet.mergeCells('C3:C4');
    worksheet.mergeCells('D3:D4');
    worksheet.mergeCells('E3:E4');

    worksheet.mergeCells('H3:H4');
    worksheet.mergeCells('I3:I4');
    worksheet.mergeCells('J3:J4');
    worksheet.mergeCells('K3:K4');
    worksheet.mergeCells('L3:L4');
    
    excelObjectData.excelRowData.forEach((row) => {  //Excel Data Loop
      const dataRow = worksheet.addRow(row);
      dataRow.height=null;
      let isTotalRow = false;
      row.forEach((value, index) => {
        const cell = dataRow.getCell(index + 1);
        cell.font = {  name: 'SansSerif',size:10 };
        cell.alignment = { horizontal: 'center',vertical: 'middle',wrapText: true };
        cell.border = {
          top: { style: 'thin' },
          left: { style: 'thin' },
          bottom: { style: 'thin' },
          right: { style: 'thin' },
        };
        if (value === 'TOTAL') {
          isTotalRow = true;
        }
        // Customize styling for the cells if needed
      });

      if (isTotalRow) {
        dataRow.eachCell({ includeEmpty: true }, (cell) => {
          cell.font = { name: 'SansSerif', size: 12, bold: true };
        });
      }
     
    });
    const buffer = await workbook.xlsx.writeBuffer();
    const blob = new Blob([buffer], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=UTF-8' });
    const fileName=`${excelObjectData.fileName}.${excelObjectData.fileType}`;
    FileSaver.saveAs(blob, fileName);
};


// ASI BLOCK Report 
export const generateASIBlockReport = async (excelObjectData) => {

  const workbook = new ExcelJS.Workbook();
  const worksheet = workbook.addWorksheet(excelObjectData.sheetName);

  //First Row Design and Merge cells A1:K1
  worksheet.mergeCells(excelObjectData.firstRowMergeCells);
  const firstHeaderRow = worksheet.getRow(1);
  firstHeaderRow.getCell(1).value = excelObjectData.firstRowExportDate
  firstHeaderRow.getCell(1).font = {name: 'SansSerif'};
  firstHeaderRow.getCell(1).alignment = { horizontal: 'right',vertical: 'middle',wrapText: true };
  firstHeaderRow.height = 15;
 
  
  //Second Row Design and  Merge cells A2:K2
  worksheet.mergeCells(excelObjectData.secondRowMergeCells); 
  const secondHeaderRow = worksheet.getRow(2);
  secondHeaderRow.getCell(1).value = excelObjectData.secondRowText;
  secondHeaderRow.getCell(1).font = {  bold: true,name: 'SansSerif',size:12};
  secondHeaderRow.getCell(1).alignment = { horizontal: 'center',vertical: 'middle',wrapText: true};
  secondHeaderRow.height = 20;
  secondHeaderRow.getCell(1).border = {
    top: { style: 'thin' },
    left: { style: 'thin' },
    bottom: { style: 'thin' },
    right: { style: 'thin' },
  };


   //excel English Column
   const headerRow3 = worksheet.addRow(excelObjectData.headerEnglishColumns);
   headerRow3.height=55;
   headerRow3.eachCell((cell,colNumber ) => {
     cell.font = { bold: true, name: 'SansSerif',size:10};
     cell.alignment = { horizontal: 'center',vertical: 'middle',wrapText: true };
     cell.value = breakTitle(cell.value);
     cell.border = {
       top: { style: 'thin' },
       left: { style: 'thin' },
       bottom: { style: 'thin' },
       right: { style: 'thin' },
       
     };
     const column = worksheet.getColumn(colNumber);
     column.width = 22;
       
    });

    excelObjectData.excelRowData.forEach((row) => {  //Excel Data Loop
      const dataRow = worksheet.addRow(row);
      dataRow.height=35;
       row.forEach((value, index) => {
        const cell = dataRow.getCell(index + 1);
        cell.font = {  name: 'SansSerif',size:10 };
        cell.alignment = { horizontal: 'center',vertical: 'middle',wrapText: true };
        cell.border = {
          top: { style: 'thin' },
          left: { style: 'thin' },
          bottom: { style: 'medium' },
          right: { style: 'thin' },
        };
        
        // Customize styling for the cells if needed
      });

      
     
    });
    const buffer = await workbook.xlsx.writeBuffer();
    const blob = new Blob([buffer], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=UTF-8' });
    const fileName=`${excelObjectData.fileName}.${excelObjectData.fileType}`;
    FileSaver.saveAs(blob, fileName);
};


// Listing Report  ***************
export const generateListingReport = async ({excelObjectData,fileName,dslNo,yearName}) => {

  const workbook = new ExcelJS.Workbook();

for(let i=0;i<excelObjectData.length;i++){

  let worksheet = workbook.addWorksheet(excelObjectData[i].sheetName);

  //First Row Design and Merge
  worksheet.mergeCells(excelObjectData[i].firstRowMergeCells);
  const firstHeaderRow = worksheet.getRow(1);
  firstHeaderRow.getCell(1).value = excelObjectData[i].firstRowExportDate
  firstHeaderRow.getCell(1).font = {name: 'SansSerif'};
  firstHeaderRow.getCell(1).alignment = { horizontal: 'right',vertical: 'middle',wrapText: true };
  firstHeaderRow.height = 15;
 
  
  //Second Row Design and  Merge cells
  worksheet.mergeCells(excelObjectData[i].secondRowMergeCells); 
  const secondHeaderRow = worksheet.getRow(2);
  secondHeaderRow.getCell(1).value = excelObjectData[i].secondRowText;
  secondHeaderRow.getCell(1).font = {name: 'SansSerif',size:18,color: { argb: 'ff7966' }};
  secondHeaderRow.getCell(1).alignment = { horizontal: 'center',vertical: 'middle',wrapText: true};
  secondHeaderRow.height = 25;
  secondHeaderRow.getCell(1).border = {
    top: { style: 'thin' },
    left: { style: 'thin' },
    bottom: { style: 'thin' },
    right: { style: 'thin' },
  };

  //Third Row Design and  Merge cells
  worksheet.mergeCells(excelObjectData[i].thirdRowMergeCells); 
  const thirdHeaderRow = worksheet.getRow(3);
  thirdHeaderRow.getCell(1).value = excelObjectData[i].thirdRowText;
  thirdHeaderRow.getCell(1).font = {name: 'SansSerif',size:14};
  thirdHeaderRow.getCell(1).alignment = { horizontal: 'center',vertical: 'middle',wrapText: true};
  thirdHeaderRow.height = 20;
  thirdHeaderRow.getCell(1).border = {
    top: { style: 'thin' },
    left: { style: 'thin' },
    bottom: { style: 'thin' },
    right: { style: 'thin' },
  };

  if(i===2){
    worksheet = blockCSheet(worksheet,dslNo,yearName);
  }else if(i===3){
    worksheet = blockDSheet(worksheet,dslNo,yearName);
  }else if(i===4){
    worksheet = blockESheet(worksheet,dslNo,yearName);
  }else if(i===5){
    worksheet = blockFSheet(worksheet,dslNo,yearName);
  }else if(i===6){
    worksheet = blockGSheet(worksheet,dslNo,yearName);
  }else if(i===7){
    worksheet = blockHSheet(worksheet,dslNo,yearName);
  }else if(i===8){
    worksheet = blockISheet(worksheet,dslNo,yearName);
  }else if(i===9){
    worksheet = blockJSheet(worksheet,dslNo,yearName);
  }else if(i===10){
    worksheet = blockKSheet(worksheet,dslNo,yearName);
  }else if(i===11){
    worksheet = blockLSheet(worksheet,dslNo,yearName);
  }



   //excel English Column *****************
   const headerRow4 = worksheet.addRow(excelObjectData[i].headerEnglishColumns);
   if(i===2){  //block C conditon 
    headerRow4.height=20;
   }else{
    headerRow4.height=55;
   }
   headerRow4.eachCell((cell,colNumber ) => {
     cell.font = { bold: true, name: 'SansSerif',size:10};
     cell.alignment = { horizontal: 'center',vertical: 'middle',wrapText: true };
     cell.value = breakTitle(cell.value);
     cell.border = {
       top: { style: 'thin' },
       left: { style: 'thin' },
       bottom: { style: 'thin' },
       right: { style: 'thin' },
       
     };
      const column = worksheet.getColumn(colNumber);
      if(i===2){  //block C Condition
        column.width =(colNumber===1)? 25 :15
      }else if (i===3){  //block D Condition
        column.width = 50;
      }else if (i===4){ //block E Condition
        column.width =(colNumber===1)? 45 :20
      }else if (i===5){ //block F Condition
        column.width =(colNumber===1)? 70 :20
     }else if (i===6){ //block G Condition
        column.width =(colNumber===1)? 70 :20
     }else if (i===7){ //block H Condition
        column.width =(colNumber===1)? 50 :30
     }else if (i===8){ //block I Condition
        column.width =(colNumber===1)? 50 :30
     }else if (i===9){ //block J Condition
        column.width =(colNumber===1)? 35 :15
     }else if (i===10){ //block K Condition
        column.width =(colNumber===1)? 70 :20
     }else if (i===11){ //block L Condition
        column.width =(colNumber===1)? 50 :30
      }else{
        column.width = 15;
      }
   });


  if(i===4){ //block E Condition
    const headerRow6 = worksheet.addRow([ '1','2','3','4','5','6','7']);
    headerRow6.eachCell((cell,colNumber ) => {
      cell.font = { bold: true, name: 'SansSerif',size:10};
      cell.alignment = { horizontal: 'center',vertical: 'middle',wrapText: true };
      cell.value = breakTitle(cell.value);
      cell.border = {
        top: { style: 'thin' },
        left: { style: 'thin' },
        bottom: { style: 'thin' },
        right: { style: 'thin' },
     };
    });
 }
  if(i===7 || i===8 ){ //block H, I Condition
    const headerRow6 = worksheet.addRow([ '1','2','3','4','5','6']);
    headerRow6.eachCell((cell,colNumber ) => {
      cell.font = { bold: true, name: 'SansSerif',size:10};
      cell.alignment = { horizontal: 'center',vertical: 'middle',wrapText: true };
      cell.value = breakTitle(cell.value);
      cell.border = {
        top: { style: 'thin' },
        left: { style: 'thin' },
        bottom: { style: 'thin' },
        right: { style: 'thin' },
     };
    });
 }

 if(i===9){ // Block J Condition 

  worksheet.mergeCells("G5:J5"); 

  const headerRow4 = worksheet.addRow(['','','','','','','Excise','Sales','Others','Total','','']);

    headerRow4.height=20;
    headerRow4.eachCell((cell,colNumber ) => {
    cell.font = { bold: true, name: 'SansSerif',size:10};
    cell.alignment = { horizontal: 'center',vertical: 'middle',wrapText: true };
    cell.value = breakTitle(cell.value);
    cell.border = {
      top: { style: 'thin' },
      left: { style: 'thin' },
      bottom: { style: 'thin' },
      right: { style: 'thin' },
      
      };
 
});




  worksheet.mergeCells("A5:A6"); 
  worksheet.mergeCells("B5:B6"); 
  worksheet.mergeCells("C5:C6"); 
  worksheet.mergeCells("D5:D6"); 
  worksheet.mergeCells("E5:E6"); 
  worksheet.mergeCells("F5:F6"); 
  


  worksheet.mergeCells("K5:K6"); 
  worksheet.mergeCells("L5:L6"); 

 }

 if(i===11){ //Block L condition 
    worksheet.mergeCells("A6:B6"); 
    const thirdHeaderRow = worksheet.getRow(6);
    thirdHeaderRow.getCell(1).value = "Have any measures been taken during last financial year with regard to";
    thirdHeaderRow.getCell(1).font = {bold: true,name: 'SansSerif',size:10};
    thirdHeaderRow.getCell(1).alignment = { horizontal: 'left',vertical: 'middle',wrapText: true};
    thirdHeaderRow.height = 20;
    thirdHeaderRow.getCell(1).border = {
      top: { style: 'thin' },
      left: { style: 'thin' },
      bottom: { style: 'thin' },
      right: { style: 'thin' },
    };

}

 
  //Excel Data Loop *****************
    excelObjectData[i].excelRowData.forEach((row) => {  
      const dataRow = worksheet.addRow(row);
      dataRow.height=20;
       row.forEach((value, index) => {
        const cell = dataRow.getCell(index + 1);
        cell.font = {  name: 'SansSerif',size:10 };
        cell.alignment = { horizontal: 'center',vertical: 'middle',wrapText: true };
        cell.border = {
          top: { style: 'thin' },
          left: { style: 'thin' },
          bottom: { style: 'thin' },
          right: { style: 'thin' },
        };
        
        // Customize styling for the cells if needed
      });

     });



    if(i===11){ //Block L condition 

      worksheet.mergeCells("A11:B11"); 
      const bottomRow1 = worksheet.getRow(11);
      bottomRow1.getCell(1).value = "GVA-NVA Calculation";
      bottomRow1.getCell(1).font = {bold: true,name: 'SansSerif',size:12};
      bottomRow1.getCell(1).alignment = { horizontal: 'center',vertical: 'middle',wrapText: true};
      bottomRow1.height = 20;
      bottomRow1.getCell(1).border = {
        top: { style: 'thin' },
        left: { style: 'thin' },
        bottom: { style: 'thin' },
        right: { style: 'thin' },
      };

      const bottomRow2 = worksheet.addRow([ 'GVA',`${excelObjectData[i]?.otherData.gva}`]);
      bottomRow2.eachCell((cell,colNumber ) => {
        cell.font = {name: 'SansSerif',size:10};
        cell.alignment = { horizontal: 'center',vertical: 'middle',wrapText: true };
        cell.value = breakTitle(cell.value);
        cell.border = {
          top: { style: 'thin' },
          left: { style: 'thin' },
          bottom: { style: 'thin' },
          right: { style: 'thin' },
       };
      });
      const bottomRow3 = worksheet.addRow([ 'NVA',`${excelObjectData[i]?.otherData.Nva}`]);
      bottomRow3.eachCell((cell,colNumber ) => {
        cell.font = {  name: 'SansSerif',size:10};
        cell.alignment = { horizontal: 'center',vertical: 'middle',wrapText: true };
        cell.value = breakTitle(cell.value);
        cell.border = {
          top: { style: 'thin' },
          left: { style: 'thin' },
          bottom: { style: 'thin' },
          right: { style: 'thin' },
       };
      });

    }

  
 } // End For Loop ************

  const buffer = await workbook.xlsx.writeBuffer();
  const blob = new Blob([buffer], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=UTF-8' });
 FileSaver.saveAs(blob, fileName);
   
};



//************** Block C Design *******************
const blockCSheet=(worksheet,dslNo,yearName)=>{

     const headerRow4 = worksheet.addRow([ 'DSL No:', '', '', `${dslNo}`,'','', 
        'Survey Year: ', '',  '', `${yearName}`, '', ''
      ]);

       headerRow4.height=20;
       headerRow4.eachCell((cell,colNumber ) => {
        if([1,2,3,7,8,9].includes(colNumber)){
          cell.font = { bold: true, name: 'SansSerif',size:10};
        }else{
          cell.font = {  name: 'SansSerif',size:10};
        }
      
      cell.alignment = { horizontal: 'center',vertical: 'middle',wrapText: true };
      cell.value = breakTitle(cell.value);
      cell.border = {
        top: { style: 'thin' },
        left: { style: 'thin' },
        bottom: { style: 'thin' },
        right: { style: 'thin' },
        
        };
    });
     worksheet.mergeCells('A4:C4');
     worksheet.mergeCells('D4:F4');
     worksheet.mergeCells('G4:I4');
     worksheet.mergeCells('J4:L4');



     const headerRow5 = worksheet.addRow([ 'Types of Assets', 'Gross Value', '', '','','', 
      'Depreciation (Rs.)', '',  '', '', 'Net Value', ''
    ]);

    headerRow5.height=20;
    headerRow5.eachCell((cell,colNumber ) => {
      cell.font = { bold: true, name: 'SansSerif',size:10};
     cell.alignment = { horizontal: 'center',vertical: 'middle',wrapText: true };
     cell.value = breakTitle(cell.value);
     cell.border = {
      top: { style: 'thin' },
      left: { style: 'thin' },
      bottom: { style: 'thin' },
      right: { style: 'thin' },
     };
  
      
   });

   worksheet.mergeCells('B5:F5');
   worksheet.mergeCells('G5:J5');
   worksheet.mergeCells('K5:L5');


    const headerRow6 = worksheet.addRow([ '','Opening As On', 'Addition During the Year' ,'', 'Deduction & adj. during the year',
     'Closing as on ( 3 + 4 + 5 - 6 )', 'Upto year beginning',  
      'Provided during the year', 'Adj. for sold/discarded during the', 'Upto year end ( 8 + 9 - 10 )', 'Opening as on 3-8','Closing as on (7-11)'
    ]);

    headerRow6.height=40;
    headerRow6.eachCell((cell,colNumber ) => {
      cell.font = { bold: true, name: 'SansSerif',size:10};
      cell.alignment = { horizontal: 'center',vertical: 'middle',wrapText: true };
      cell.value = breakTitle(cell.value);
      cell.border = {
      top: { style: 'thin' },
      left: { style: 'thin' },
      bottom: { style: 'thin' },
      right: { style: 'thin' },
     };
    
      
   });
    
   worksheet.mergeCells('C6:D6');


   const headerRow7 = worksheet.addRow([ '','', 'Due to' ,'Actual', '',
    '', '', '', '', '','',''
   ]);

   headerRow7.height=20;
   headerRow7.eachCell((cell,colNumber ) => {
     cell.font = { bold: true, name: 'SansSerif',size:10};
     cell.alignment = { horizontal: 'center',vertical: 'middle',wrapText: true };
     cell.value = breakTitle(cell.value);
     cell.border = {
     top: { style: 'thin' },
     left: { style: 'thin' },
     bottom: { style: 'thin' },
     right: { style: 'thin' },
    };

     
  });
 
  worksheet.mergeCells('A5:A7');
  worksheet.mergeCells('B6:B7');
  worksheet.mergeCells('E6:E7');
  worksheet.mergeCells('F6:F7');
  worksheet.mergeCells('G6:G7');
  worksheet.mergeCells('H6:H7');
  worksheet.mergeCells('I6:I7');
  worksheet.mergeCells('J6:J7');
  worksheet.mergeCells('K6:K7');
  worksheet.mergeCells('L6:L7');
   
  return worksheet;
}



// ******************Block D Design ******************
const blockDSheet=(worksheet,dslNo,yearName)=>{
    const headerRow4 = worksheet.addRow([ `DSL No: ${dslNo}`,'',
      `Survey Year: ${yearName}`
    ]);

    headerRow4.height=20;
    headerRow4.eachCell((cell,colNumber ) => {
    cell.font = { bold: true, name: 'SansSerif',size:10};
    cell.alignment = { horizontal: 'center',vertical: 'middle',wrapText: true };
    cell.value = breakTitle(cell.value);
    cell.border = {
      top: { style: 'thin' },
      left: { style: 'thin' },
      bottom: { style: 'thin' },
      right: { style: 'thin' },
      
      };
     
  });

 return worksheet;
}


//  **************** Block E Design **************
const blockESheet=(worksheet,dslNo,yearName)=>{
    const headerRow4 = worksheet.addRow([ `DSL No:`,`${dslNo}`,'','',`Survey Year:`,'',
      `${yearName}`
    ]);

   headerRow4.height=20;
   headerRow4.eachCell((cell,colNumber ) => {

  if([1,5,6].includes(colNumber)){
    cell.font = { bold: true, name: 'SansSerif',size:10};
  }else{
    cell.font = {  name: 'SansSerif',size:10};
  }
  cell.alignment = { horizontal: 'center',vertical: 'middle',wrapText: true };
  cell.value = breakTitle(cell.value);
  cell.border = {
    top: { style: 'thin' },
    left: { style: 'thin' },
    bottom: { style: 'thin' },
    right: { style: 'thin' },
    
    };
   
  });
  worksheet.mergeCells('B4:C4')
  worksheet.mergeCells('E4:F4')
  return worksheet;
}

//  **************** Block F Design **************
const blockFSheet=(worksheet,dslNo,yearName)=>{



  worksheet.mergeCells('A4:B4'); 
  const headerRow4 = worksheet.getRow(4);
  headerRow4.getCell(1).value =`DSL No: ${dslNo}               Survey Year: ${yearName}`;
  headerRow4.getCell(1).font = {bold: true, name: 'SansSerif',size:10};
  headerRow4.getCell(1).alignment = { horizontal: 'center',vertical: 'middle',wrapText: true};
  headerRow4.height = 20;
  headerRow4.getCell(1).border = {
    top: { style: 'thin' },
    left: { style: 'thin' },
    bottom: { style: 'thin' },
    right: { style: 'thin' },
  };


  return worksheet;
}


//  **************** Block G Design **************
const blockGSheet=(worksheet,dslNo,yearName)=>{



  worksheet.mergeCells('A4:B4'); 
  const headerRow4 = worksheet.getRow(4);
  headerRow4.getCell(1).value =`DSL No: ${dslNo}               Survey Year: ${yearName}`;
  headerRow4.getCell(1).font = {bold: true, name: 'SansSerif',size:10};
  headerRow4.getCell(1).alignment = { horizontal: 'center',vertical: 'middle',wrapText: true};
  headerRow4.height = 20;
  headerRow4.getCell(1).border = {
    top: { style: 'thin' },
    left: { style: 'thin' },
    bottom: { style: 'thin' },
    right: { style: 'thin' },
  };


  return worksheet;
}


//  **************** Block H Design **************
const blockHSheet=(worksheet,dslNo,yearName)=>{

  const headerRow4 = worksheet.addRow([ `DSL No:`,`${dslNo}`,'',`Survey Year:`,'',
    `${yearName}`
  ]);

    headerRow4.height=20;
    headerRow4.eachCell((cell,colNumber ) => {

    if([1,4].includes(colNumber)){
      cell.font = { bold: true, name: 'SansSerif',size:10};
    }else{
      cell.font = {  name: 'SansSerif',size:10};
    }
    cell.alignment = { horizontal: 'center',vertical: 'middle',wrapText: true };
    cell.value = breakTitle(cell.value);
    cell.border = {
      top: { style: 'thin' },
      left: { style: 'thin' },
      bottom: { style: 'thin' },
      right: { style: 'thin' },
      
      };
    
    });
    worksheet.mergeCells('B4:C4')
    worksheet.mergeCells('D4:E4')


  return worksheet;
}



//  **************** Block I Design **************
const blockISheet=(worksheet,dslNo,yearName)=>{

    const headerRow4 = worksheet.addRow([ `DSL No:`,`${dslNo}`,'',`Survey Year:`,'',
      `${yearName}`
    ]);
    headerRow4.height=20;
    headerRow4.eachCell((cell,colNumber ) => {

    if([1,4].includes(colNumber)){
      cell.font = { bold: true, name: 'SansSerif',size:10};
    }else{
      cell.font = {  name: 'SansSerif',size:10};
    }
    cell.alignment = { horizontal: 'center',vertical: 'middle',wrapText: true };
    cell.value = breakTitle(cell.value);
    cell.border = {
      top: { style: 'thin' },
      left: { style: 'thin' },
      bottom: { style: 'thin' },
      right: { style: 'thin' },
      
      };
   });
    worksheet.mergeCells('B4:C4')
    worksheet.mergeCells('D4:E4')
   return worksheet;
}


//  **************** Block J Design **************
const blockJSheet=(worksheet,dslNo,yearName)=>{

    const headerRow4 = worksheet.addRow([ `DSL No:`,'',`${dslNo}`,'','','',`Survey Year:`,'','','',
      `${yearName}`,''
    ]);
    headerRow4.height=20;
    headerRow4.eachCell((cell,colNumber ) => {

    if([1,7].includes(colNumber)){
      cell.font = { bold: true, name: 'SansSerif',size:10};
    }else{
      cell.font = {  name: 'SansSerif',size:10};
    }
    cell.alignment = { horizontal: 'center',vertical: 'middle',wrapText: true };
    cell.value = breakTitle(cell.value);
    cell.border = {
      top: { style: 'thin' },
      left: { style: 'thin' },
      bottom: { style: 'thin' },
      right: { style: 'thin' },
      
      };
   });
    worksheet.mergeCells('A4:B4')
    worksheet.mergeCells('C4:F4')
    worksheet.mergeCells('G4:J4')
    worksheet.mergeCells('K4:L4')
   return worksheet;
}


//  **************** Block K Design **************
const blockKSheet=(worksheet,dslNo,yearName)=>{

    worksheet.mergeCells('A4:B4'); 
  const headerRow4 = worksheet.getRow(4);
  headerRow4.getCell(1).value =`DSL No: ${dslNo}               Survey Year: ${yearName}`;
  headerRow4.getCell(1).font = {bold: true, name: 'SansSerif',size:10};
  headerRow4.getCell(1).alignment = { horizontal: 'center',vertical: 'middle',wrapText: true};
  headerRow4.height = 20;
  headerRow4.getCell(1).border = {
    top: { style: 'thin' },
    left: { style: 'thin' },
    bottom: { style: 'thin' },
    right: { style: 'thin' },
  };


  return worksheet;
}



//  **************** Block L Design **************
const blockLSheet=(worksheet,dslNo,yearName)=>{

  worksheet.mergeCells('A4:B4'); 
  const headerRow4 = worksheet.getRow(4);
  headerRow4.getCell(1).value =`DSL No: ${dslNo}               Survey Year: ${yearName}`;
  headerRow4.getCell(1).font = {bold: true, name: 'SansSerif',size:10};
  headerRow4.getCell(1).alignment = { horizontal: 'center',vertical: 'middle',wrapText: true};
  headerRow4.height = 20;
  headerRow4.getCell(1).border = {
    top: { style: 'thin' },
    left: { style: 'thin' },
    bottom: { style: 'thin' },
    right: { style: 'thin' },
  };

  return worksheet;
}




// Block A Report
export const BlockASheet = async (excelObjectData) => {

  const workbook = new ExcelJS.Workbook();
  let  worksheet = workbook.addWorksheet(excelObjectData.sheetName);
  worksheet=  threeHeaderRowData(worksheet,excelObjectData)
 
  //excel English Column
    const headerRow3 = worksheet.addRow(excelObjectData.headerEnglishColumns);
    headerRow3.height=55;
    headerRow3.eachCell((cell,colNumber ) => {
      cell.font = { bold: true, name: 'SansSerif',size:10};
      cell.alignment = { horizontal: 'center',vertical: 'middle',wrapText: true };
      cell.value = breakTitle(cell.value);
      cell.border = {
        top: { style: 'thin' },
        left: { style: 'thin' },
        bottom: { style: 'thin' },
        right: { style: 'thin' },
        
      };
      const column = worksheet.getColumn(colNumber);
      column.width = 16;
        
     });


  excelObjectData.excelRowData.forEach((row) => {  //Excel Data Loop
      const dataRow = worksheet.addRow(row);
      dataRow.height='25';
   
      row.forEach((value, index) => {
        const cell = dataRow.getCell(index + 1);
        cell.font = {  name: 'SansSerif',size:10 };
        cell.alignment = { horizontal: 'center',vertical: 'middle',wrapText: true };
        cell.border = {
          top: { style: 'thin' },
          left: { style: 'thin' },
          bottom: { style: 'medium' },
          right: { style: 'thin' },
        };
    
        // Customize styling for the cells if needed
      });

  
     
    });
    const buffer = await workbook.xlsx.writeBuffer();
    const blob = new Blob([buffer], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=UTF-8' });
    const fileName=`${excelObjectData.fileName}.${excelObjectData.fileType}`;
    FileSaver.saveAs(blob, fileName);
};


const threeHeaderRowData=(worksheet,excelObjectData)=>{

      //First Row Design and Merge cells 
      worksheet.mergeCells(excelObjectData.firstRowMergeCells);
      const firstHeaderRow = worksheet.getRow(1);
      firstHeaderRow.getCell(1).value = excelObjectData.firstRowExportDate
      firstHeaderRow.getCell(1).font = {name: 'SansSerif'};
      firstHeaderRow.getCell(1).alignment = { horizontal: 'right',vertical: 'middle',wrapText: true };
      firstHeaderRow.height = 15;

      
      //Second Row Design and  Merge cells 
      worksheet.mergeCells(excelObjectData.secondRowMergeCells); 
      const secondHeaderRow = worksheet.getRow(2);
      secondHeaderRow.getCell(1).value = excelObjectData.secondRowText;
      secondHeaderRow.getCell(1).font = {  bold: true,name: 'SansSerif',size:18,color: { argb: 'ff7966' }};
      secondHeaderRow.getCell(1).alignment = { horizontal: 'center',vertical: 'middle',wrapText: true};
      secondHeaderRow.height = 20;
      secondHeaderRow.getCell(1).border = {
        top: { style: 'thin' },
        left: { style: 'thin' },
        bottom: { style: 'thin' },
        right: { style: 'thin' },
      };
      //Second Row Design and  Merge cells 
      worksheet.mergeCells(excelObjectData.thirdRowMergeCells); 
      const thirdHeaderRow = worksheet.getRow(3);
      thirdHeaderRow.getCell(1).value = excelObjectData.thirdRowText;
      thirdHeaderRow.getCell(1).font = {  bold: true,name: 'SansSerif',size:14};
      thirdHeaderRow.getCell(1).alignment = { horizontal: 'center',vertical: 'middle',wrapText: true};
      thirdHeaderRow.height = 20;
      thirdHeaderRow.getCell(1).border = {
        top: { style: 'thin' },
        left: { style: 'thin' },
        bottom: { style: 'thin' },
        right: { style: 'thin' },
      };

      return worksheet;

}